(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyco-collection"]) return;
  try {
    
const PRICE_RANGE_LABELS = {
    '*-10': '$10 or less',
    '*-25': '$25 or less',
    '10-25': '$10 - $25',
    '25-50': '$25 - $50',
    '50-75': '$50 - $75',
    '75-100': '$75 - $100',
    '100-125': '$100 - $125',
    '125-150': '$125 - $150',
    '150-175': '$150 - $175',
    '175-200': '$175 - $200',
    '200-225': '$200 - $225',
    '225-250': '$225 - $250',
    '250-275': '$250 - $275',
    '275-300': '$275 - $300',
    '300-325': '$300 - $325',
    '325-350': '$325 - $350',
    '350-375': '$350 - $375',
    '375-400': '$375 - $400',
  };
const swatchColorMap = {
  	'BLACK': '#000000',
	'BLUE': '#0066FF',
	'BROWN': '#746155',
	'MULTICOLOR': '//images.ctfassets.net/x9pzmr4klqz6/4olle2ZxVZLxIp…Mesh-Button-Front-Shirt-Gabrielle-Union-x-FTF.png',
	'DENIM': '#6FA8DC',
	'GREEN': '#2E6930',
	'GREY': '#BDBDBD',
	'NATURAL': '#DECCA6',
	'ORANGE': '#FFA500',
	'PINK': '#FFC2CD',
	'PURPLE': '#660066',
	'RED': '#CC0000',
	'WHITE': '#FFFFFF',
	'YELLOW': '#FFE800'
};	
async function shopifyGraphQL(query, variables = {}) {
	  const endpoint = "https://sg-nyandco.myshopify.com/api/2025-01/graphql.json";
	  const accessToken = "9886c5c41e8507cefb505c5f68cc4b8d";

	  const response = await fetch(endpoint, {
		method: "POST",
		headers: {
		  "Content-Type": "application/json",
		  "X-Shopify-Storefront-Access-Token": accessToken,
		},
		body: JSON.stringify({ query, variables }),
	  });

	  const result = await response.json();
	  return result.data;
  }

const query = `
	query getProductsByIds($ids: [ID!]!) {
	nodes(ids: $ids) {
		... on Product {
		id
		title
		handle
		images (first:250) {
			edges {
			node {
				url
				altText
			}
			}
		}
		media(first: 50) {
			edges {
			node {
				mediaContentType
				alt
				...on Video {
				sources {
					url
					mimeType
					format
					height
					width
				}
				}
			}
			}
		}
		compareAtPriceRange {
			minVariantPrice {
			amount
			currencyCode
			}
			maxVariantPrice {
			amount
			currencyCode
			}
		}
		priceRange {
			minVariantPrice {
			amount
			currencyCode
			}
			maxVariantPrice {
			amount
			currencyCode
			}
		}
		variants(first: 1) {
			nodes {
				id
				sku
				title
				metafields(
					identifiers: [
						{namespace: "variant", key: "sale_tag"}
						{namespace: "variant", key: "badge"}
					]
				) {
					key
					value
				}
			}
		}
		metafields(
			identifiers: [
			{namespace: "product", key: "class_style_number"}
			{namespace: "product", key: "start_date"}
			{namespace: "product", key: "discount_tag"}
			{namespace: "product", key: "proportions"}
			{namespace: "custom", key: "video_autoplay"}
			{namespace: "custom", key: "video_thumbnail"}
			{namespace: "product", key: "product_class"}
			{namespace: "product", key: "product_department"}
			{namespace: "product", key: "product_division"}
			]
		) {
			key
			value
		}
		}
	}
	}
`;
	
  const generateProductMap = (products) => {
	const productMap = {};
	products.forEach((p) => {
		const pid = p?.id?.replace('gid://shopify/Product/', '');
		productMap[pid] = p;
	})
	return productMap; 
  }  
  
  const findColorImages = (color_name, color_family, imageMap) => {
	  let swatchAltText = '#swatch_' + color_name;
	  let avAltText = '#color_' + color_name;
	  let swatchImage = imageMap?.[swatchAltText];
	  let avImages = imageMap?.[avAltText];
	  if (swatchImage || (avImages && avImages.length)) {	 
		return {
			"swatchImage" : swatchImage?.[0].url,
			"primaryImage": avImages?.[0]?.url,
			"hoverImage": avImages?.length > 1 ? avImages?.[1]?.url : avImages?.[0]?.url,
		};	  
	  }
	  swatchAltText = '#swatch_' + color_family;
	  avAltText = '#color_' + color_family;
	  swatchImage = imageMap?.[swatchAltText];
	  avImages = imageMap?.[avAltText];
	  return {
		"swatchImage" : swatchImage?.[0].url,
		"primaryImage": avImages?.[0]?.url,
		"hoverImage": avImages?.length > 1 ? avImages?.[1]?.url : avImages?.[0]?.url,
	  };
	}
  
  const mergeProductProperties = (products, shopifyProducts) => {
	const productMap = generateProductMap(shopifyProducts?.nodes);
	products?.forEach((p) => {
		const sfPrd = productMap[p.id];
		p.compareAtPriceRange = sfPrd?.compareAtPriceRange;
		p.metafields = sfPrd?.metafields;
		p.options = sfPrd?.options;
		p.priceRange = sfPrd?.priceRange;
		if (p?.relevantDocument === 'variant') {
		  const v_images = p?.variants?.[0]?.v_images?.filter(
			(v_img) => !v_img?.includes('_sw'),
		  );
		  p.v_images = v_images?.length && v_images.toReversed();
		}
		const colorImageMap = {};
		sfPrd?.images?.edges?.forEach(
			(img) => {
				if (!colorImageMap.hasOwnProperty(img?.node?.altText)) {
					colorImageMap[img?.node?.altText] = []
				}
				colorImageMap[img?.node?.altText].push(img?.node);
			}
		);
		const availableColorInfos = getAvailableColors(p);
		p.availableColors = availableColorInfos?.map((colorInfo) => {
			const colorImages = findColorImages(
				colorInfo?.color_name,
				colorInfo?.color_family,
				colorImageMap,
			)
			return {
				color_family: colorInfo?.color_family,
				color_name: colorInfo?.color_name,
				color_swatch_image: colorImages?.["swatchImage"],
				primary_image: colorImages?.["primaryImage"],
				hover_image: colorImages?.["hoverImage"],
			}
		});
		p.shopify_variants = sfPrd?.variants;
		p.images = sfPrd?.images;
		p.media = sfPrd?.media;
		// p.id = p.id;
		p.product_department = getMetafield('product_department', sfPrd);
		p.product_class = getMetafield('product_class', sfPrd);
		p.product_division = getMetafield('product_division', sfPrd);
	})
	return products;
  }
  
  const getVariantMetafield = (key, entity) => {
	  const metafield = entity?.[key];
	  if (!metafield) return undefined;
	  let value = metafield;

	  // Just in case we find a list or JSON object type value, try parsing it
	  try {
		value = JSON.parse(value);
	  } catch (e) {
		// Wasn't a JSON-parseable field
	  }

	  return value;
  };
  
	const getMetafield = (key, entity) => {
	  const metafield = entity?.metafields?.find((mf) => mf?.key === key);
	  if (!metafield) return undefined;
	  let value = metafield.value;

	  // Just in case we find a list or JSON object type value, try parsing it
	  try {
		value = JSON.parse(value);
	  } catch (e) {
		// Wasn't a JSON-parseable field
	  }

	  return value;
	}
  
  function isNewArrival(date, daysOld = 90) {
	  return (
		new Date(date).valueOf() >
		new Date().setDate(new Date().getDate() - daysOld).valueOf()
	  );
  }
  
  const getDiscountTag = (product) => {
	const discountTag = getMetafield('discount_tag', product);
	let firstDiscountTag = discountTag?.[0]?.split(':')?.[1];
	return firstDiscountTag;
  }
  
  const getBadge = (product, variant) => {
	  const startDate = getMetafield('start_date', product);
	  const variantBadge = variant
		? getVariantBadge(variant)
		: getVariantBadge(product?.shopify_variants?.nodes?.[0]);

	  let badge = '';
	  if (isNewArrival(startDate)) {
		badge = 'New';
	  }

	  if (variantBadge) {
		badge = variantBadge;
	  }

	  return badge;
  };

	const bwlDepts = [26, 27, 30, 32, 33, 34, 35, 36, 37, 38];
	function isBWLProduct(product) {
	  const prodDept = product.product_department;
	  if (bwlDepts && bwlDepts.length && bwlDepts.includes(prodDept)) {
		return true;
	  }
	  return false;
	}
	const getOtherProportions = (product) => {
	  const proportions = getMetafield('proportions', product)?.map((p, index, ds) => {
        const split = p?.split('|');
        if (split?.length > 1 && index > 0) {
          return `${split[0]} ${index < ds?.length - 1 ? ' and ' : ''}`;
        }
        return '';
      });
	  return proportions;
	}

	const getVariantBadge = (variant) => {
	  const badges = {
		NYDEAL: 'NY Deal',
		'NY Deal': 'NY Deal',
		STYLEDEAL: 'Style Deal',
		'Style Deal': 'Style Deal',
		CITYSTEAL: 'City Steal',
		'City Steal': 'City Steal',
		GREATFIND: 'Great Find',
		'Great Find': 'Great Find',
		CYBERDEAL: 'Cyber Deal',
		'Cyber Deal': 'Cyber Deal',
		PREORDER: 'PREORDER',
		'PRE ORDER': 'PREORDER',
		ALMOSTGONE: 'Almost Gone!',
		'Almost Gone': 'Almost Gone!',
		BESTSELLER: 'Best Seller',
		'Best Seller': 'Best Seller',
		BACKINSTOCK: 'Back In Stock',
		'Back In Stock': 'Back In Stock',
		NEWTOSALE: 'New to Sale',
		'New to Sale': 'New to Sale',
		PRICEDROPPED: 'Price dropped',
		'Price dropped': 'Price dropped',
		TOPRATED: 'Top Rated',
		'Top Rated': 'Top Rated',
		TRENDINGNOW: 'Trending Now',
		'Trending Now': 'Trending Now',
		INDEMAND: 'In Demand',
		'In Demand': 'In Demand',
		NYDEALS: 'NY Deals',
		'NY Deals': 'NY Deals',
		NEWCOLOR: 'New Color',
		'New Color': 'New Color',
		PLUSSIZES: 'Plus Sizes',
		'Plus Sizes': 'Plus Sizes',
		SELLINGFAST: 'Selling Fast',
		'Selling Fast': 'Selling Fast',
	  };
	  const variantBadge = getMetafield('badge', variant);
	  return badges[variantBadge];
	};
  
	const generatePriceRangeKey = (facetValues, i, gap) => {
	  const start = i == 0 ? '*' : parseInt(facetValues[i]);
	  const end = parseInt(facetValues[i]) + gap;
	  return `${start}-${end}`;
	};

	const retrieveFacets = (facetList) => {
		const filters = [];
		if (facetList && facetList.length) {
			facetList.forEach((facet) => {
			  const facetName = facet.label;
			  let generateKey = false;
			  let facetValues = [];
			  if (Array.isArray(facet?.values)) {
				facetValues = facet?.values;
			  } else {
				facetValues = facet?.values?.counts;
				generateKey = true;
				facet.filterField = facet.label;
			  }
			  if (allowedFilters?.length == 0 || allowedFilters?.indexOf(label) > -1) {
				const facetArray = [];
				for (let i = 0; i < facetValues?.length - 1; i = i + 2) {
				  facetArray.push({
					key: generateKey
					  ? generatePriceRangeKey(facetValues, i, facet?.values?.gap || 10)
					  : facetValues?.[i],
					doc_count: facetValues?.[i + 1],
				  });
				}
				facet.displayName = facet.label;
				facet.values = facetValues;
			  }
			  filters.push(facet);
			});
		  }
		  return filters;
	};
	
	const filterSortWrapper = document.querySelector("#filter-sort-wrapper");
	const noResultFound = document.querySelector("#no-result-found");
	const styleCountEl = document.querySelector("#style-count");
    const grid = document.getElementById("productGrid");
    const topLoader = document.getElementById("loadingIndicatorTop");
	const loader = document.getElementById("loadingIndicatorBottom");
    const topObserverEl = document.getElementById('loadingIndicatorTop');
	const bottomObserverEl = document.getElementById('loadingIndicatorBottom');
    const overlayEl = document.getElementById('overlay');
	const filtersPanel = document.getElementById("filtersPanel");
    const filterToggle = document.getElementById("filterToggle");
    const sortToggle = document.getElementById("sortToggle");
    const sortCloseBtn = document.querySelector(".sort-close");
	const sortPanel = document.getElementById("sortPanel");
	const sortValue = document.getElementById("selectedSort");
    
	let isMobile = window.innerWidth <= 1024;
	let selectedFilters = {};   // e.g. { category: ["Shoes", "Shirts"], color: ["Red"] }
    let selectedSort = "";
	let pageNoToAppend;
    let page = 1;
	let firstPageNumber = 1;
	let lastPageNumber = 1;
    let initialLoad = true;
	let loading = false;
    let lastPage = false;
	let totalPages = 0;
	let productCount = 0;
	let observingTopSentinel = false;
	let observingBottomSentinel = false;
	const pageSize = 12;
	const currentUrl = new URL(window.location.href);
	async function fetchProducts({ page, filters, sort }) {
      const params = {
		page,
		sortBy: sort,
		collectionId,
		handle,
		filters,
		userAgent : navigator.userAgent
	  };
	  const data = await getCollectionResults(params);
	  productCount = data?.total_product;	  
	  const start = (page - 1) * pageSize;
      const end = start + pageSize;
      lastPage = end >= productCount;
	  totalPages = (productCount % pageSize) === 0 ? productCount / pageSize : parseInt(productCount / pageSize) + 1;
	  return data;      
    }

	const calculatePriceRange = (product) => {
	  	const productComparePriceMax =
			product?.compareAtPriceRange?.maxVariantPrice?.amount;
		const productComparePriceMin =
			product?.compareAtPriceRange?.minVariantPrice?.amount;

		const productPriceMin = product?.priceRange?.minVariantPrice?.amount;
		const productPriceMax = product?.priceRange?.maxVariantPrice?.amount;
		
		const firstDiscountTag = getDiscountTag(product);
		const priceMinMaxEqual = productPriceMin === productPriceMax;
		if(priceMinMaxEqual &&
			Number(productComparePriceMax) >= Number(productPriceMin)) {
		  if (Number(productComparePriceMax) === Number(productPriceMin)) {
			  return {
				  type: "list-price",
				  listPrice: Number(productComparePriceMax),
				  priceForGTM: Number(productComparePriceMax),
				  discountTag: firstDiscountTag
				};
			} else {
			  return {
				  type: "no-range",
				  listPrice: Number(productComparePriceMax),
				  salePrice: Number(productPriceMin),
				  priceForGTM: Number(productPriceMin),
				  discountTag: firstDiscountTag
				};
			}
		} else {
			{/* Different discounts for variants */}
			if (productPriceMin !== productPriceMax &&
			  Number(productComparePriceMax) > Number(productPriceMin)) {
				return {
				  type: "range",
				  listPrice: Number(productComparePriceMax),
				  minSalePrice: Number(productPriceMin),
				  maxSalePrice: Number(productPriceMax),
				  priceForGTM: Number(productPriceMin),
				  discountTag: firstDiscountTag
				};
			}

			{/* No discount */}
			if (Number(productComparePriceMax) < Number(productPriceMin)) {
			  if (productPriceMin !== productPriceMax) {
				  return {
					  type: "sale-price-range",
					  minSalePrice: Number(productPriceMin),
					  maxSalePrice: Number(productPriceMax),
					  priceForGTM: Number(productPriceMin),
					};
				} else {
				   return {
					  type: "list-price",
					  listPrice: Number(productPriceMin),
					  priceForGTM: Number(productPriceMin),
					  discountTag: firstDiscountTag
					};
				}
			}
		}

	  // Fallback (covers minSale == maxSale but < listPrice)
	  return {
		type: "single-sale",
		listPrice: Number(productComparePriceMax),
		salePrice: Number(productPriceMin),
		priceForGTM: Number(productPriceMin),
	  };
	}	

	const renderProductCard = (product) => {	
        const card = document.createElement("div");
		card.dataset.pageNo = page;
		card.id = product.id;
		const productUrl = `/products/${product?.handle}`;
		const badge = getBadge(product);
		const wishlistHeart = (document.getElementById('rivo-heart-template') || {}).innerHTML || '';
		
        card.className = "overflow-hidden relative card-nyco-product";
		const badgeHtml = badge ? `<span class="absolute mt-[5px] sm:mt-2 right-[5px] sm:right-2 bg-white text-black text-[10px] sm:text-xs px-[6px] sm:px-2 py-[2px] sm:py-1 rounded-full">
								${badge}
							</span>${wishlistHeart}` : `${wishlistHeart}`;
				const priceRange = calculatePriceRange(product);
		const discountMsg = priceRange?.discountTag;					  
		// add margin-left: auto; margin-right: auto; to center align bwl badge
		const bwlHtml = isBWLProduct(product) ? `<div
						class="mb-[5px] text-[10px]/[15px] uppercase text-dusty" style="letter-spacing: .02em; font-weight: 500"
					>
						Brands We Love
					</div>` : '';
		const proportions = getOtherProportions(product)?.join("");			
		const proportionHtml = proportions ? `<div
            class="mb-[5px] text-[10px]/[15px] uppercase text-dusty" style="letter-spacing: .02em; font-weight: 500"
          >
            Available in ${proportions}
          </div>` : '';	

		//const discountMsg = getDiscountTag(product);	
		
		let discountMsgHtml = '';
		if (discountMsg && discountMsg.length) {
			discountMsgHtml = `<div
								class="mb-[5px] text-[11px]/[16px] font-semibold display_none md:inline-block" style="letter-spacing: .02em;"
							  >`;
			discountMsg.split(',').forEach((discountTag, index) => (
			  discountMsgHtml = `${discountMsgHtml}<p class="mb-0">
			    ${discountTag}
			  </p>`
		    ))
			discountMsgHtml = `${discountMsgHtml}</div>`;
		}		
		
		let priceRangeHtml = '';
		if (priceRange) {
			if (priceRange.type === 'range') {
				priceRangeHtml = `<div class="flex flex-wrap">
                  <div class="w-full flex mb-[6px]">
                    <div class="line-through opacity-[0.4]">
                      $${priceRange.listPrice}
                    </div>

                    <div class="flex text-ruby ml-2">
                      $${priceRange.minSalePrice}&nbsp;
                      &#8211;&nbsp;
                      $${priceRange.maxSalePrice}
                    </div>
                  </div>
				</div>`;
			}
			else if (priceRange.type === 'list-price') {
				priceRangeHtml = `<div class="flex flex-wrap">
					${priceRange.listPrice}
				</div>`;
			}
			else if (priceRange.type === 'no-range') {
				priceRangeHtml = `<div class="flex flex-wrap">
					<div class="w-full flex mb-[6px]">
					  <div class="line-through opacity-[0.4]">
						$${priceRange.listPrice}
					  </div>

					  <div class="flex text-ruby ml-2">
						$${priceRange.salePrice}
					  </div>
					</div>
				</div>`;
			}
			else if (priceRange.type === 'sale-price-range') {
				priceRangeHtml = `<div class="flex">
                    <div class="flex">
                      $${priceRange.minSalePrice}&nbsp;
                      &#8211;&nbsp;
                      $${priceRange.maxSalePrice}
                    </div>
                  </div>`;
			}			
		}
		const placeholderImage =
			'https://cdn.shopify.com/s/files/1/0554/0718/2011/files/NYCO_Placeholder_image.avif?v=1704875304';
			
		const firstImage =
		  product?.v_images && product?.v_images?.length
			? product?.v_images[0]
			: product?.images?.edges?.length > 0
			? product?.images?.edges[0]?.node?.url
			: placeholderImage;

		const videoSources =
		  product?.media?.edges?.length > 1 &&
		  product?.media?.edges[1]?.node?.mediaContentType === 'VIDEO' &&
		  product?.media?.edges[1]?.node?.sources;
		let videoUrl;
		if (videoSources?.length) {
		  const videoUrls = videoSources.filter(
			(videoSrc) => videoSrc?.format !== 'm3u8',
		  );
		  videoUrl = videoUrls?.length ? videoUrls[0].url : videoSources[0].url;
		}
	    const altImage = videoUrl
		  ? videoUrl
		  : product?.v_images && product?.v_images?.length > 1
		  ? product?.v_images[1]
		  : product?.images?.edges?.length > 1
		  ? product?.images?.edges[1]?.node?.url
		  : placeholderImage;
	  
		const quickViewButtonMob = `<div data-quick-view 
			class="absolute z-5 right-[5px] p-[10px] bottom-1 display_block 
			lg:display_none cursor-pointer"
			data-product-title="${product.title}"
			data-product-handle=${product.handle}
			data-discount-tags=${JSON.stringify(discountMsg)}
			data-price="${priceRange?.['priceForGTM']}"
			data-image="${firstImage}"
			>
				<svg width="15" height="19" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M9.08345 6.0835V8.1665H10.3334V6.0835H11.6639L12.2417 14.7503C12.2897 15.4718 11.7175 16.0835 10.9944 16.0835H3.00552C2.28244 16.0835 1.71019 15.4718 1.75829 14.7503L2.33608 6.0835H3.66678V8.1665H4.91678V6.0835H9.08345ZM10.3334 4.8335H12.8333L13.4889 14.6672C13.5851 16.1102 12.4406 17.3335 10.9944 17.3335H3.00552C1.55936 17.3335 0.414858 16.1102 0.511055 14.6672L1.16664 4.8335H3.66678V3.99984C3.66678 2.15889 5.15917 0.666504 7.00012 0.666504C8.84106 0.666504 10.3334 2.15889 10.3334 3.99984V4.8335ZM4.91678 4.8335V3.99984C4.91678 2.84924 5.84952 1.9165 7.00012 1.9165C8.15071 1.9165 9.08345 2.84924 9.08345 3.99984V4.8335H4.91678Z" fill="#171011">
				</path>
				</svg>
			</div>`;	
		const quickViewButton = `<button 
			type="button"
			class="quick-view-btn absolute left-[5px] right-[5px] p-[10px] bg-white/[.9] z-10 transition-bottom ease-in-out
					delay-150 duration-[700ms] bottom-[25px] uppercase display_none lg:display_block"
			data-quick-view
			data-product-title="${product.title}"
			data-product-handle=${product.handle}
			data-discount-tags=${JSON.stringify(discountMsg)}
			data-price="${priceRange?.['priceForGTM']}"
			data-image="${firstImage}"
			>
			Quick View
			</button>`;			  
		const mainImageHtml = `<img class="primary-img absolute inset-0 w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-0"
			src="${firstImage}" alt="${product.title}" loading="lazy" sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw">`;
		const hoverImageHtml = videoUrl ?
		`<video class="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100"
           preload="none" autoplay muted loop playsinline>
		  <source src="${videoUrl}" type="video/mp4">
		</video>`
		: `<img class="hover-img absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-300 group-hover:opacity-100" 
			src="${altImage}" alt="${product.title}" loading="lazy" sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw">`;
		<!-- old starts -->
		card.innerHTML = `
		  <div class="card-product group relative w-full aspect-[3/4] overflow-hidden">
		  	<!-- Media wrapper wrapped with link -->
		  	<a class="product-link block relative w-full aspect-[3/4] overflow-hidden" href="${productUrl}">
			  ${mainImageHtml}
			  ${hoverImageHtml}
			  ${badgeHtml}	
			</a>
			${quickViewButtonMob}
			${quickViewButton}
		  </div>
          <div class="px-1 sm:px-2 md:px-3 lg:px-4 py-3">
			<div class="swatches flex mb-2"></div>
			${bwlHtml}
			${proportionHtml}
            <a class="product-link block product-title" href="${productUrl}">
			  <h3 class="text-sm font-semibold">${product.title}</h3>
			</a>	
			${discountMsgHtml}
            <div class="text-black-500 text-sm font-medium product-price">${priceRangeHtml}</div>
          </div>`;
		
		card.querySelectorAll(".product-link").forEach(
			prodLinkEl => prodLinkEl.addEventListener('click', () => {
				pageNoToAppend = card.dataset.pageNo;
				updateURL();
				window.GTMEventBus.publish(eventConstants.SELECT_ITEM, {product, handle});
			})
		)
		// Swatches
		const swatchesContainer = card.querySelector(".swatches");
		let foundDefaultSwatch = false;
		product.availableColors.forEach((colorInfo, i) => {
			const swatch = document.createElement("button");
			const primaryImage = colorInfo?.["primary_image"];
			const hoverImage = colorInfo?.["hover_image"];
			const isSelected = !foundDefaultSwatch && (firstImage === primaryImage || firstImage === hoverImage);
			if (isSelected) {
				foundDefaultSwatch = true;
			}
			swatch.className = "rounded-full swatch" + (isSelected ? " selected" : "");
			swatch.innerHTML = `<img
				width="18"
				height="18"
				title="${colorInfo.color_name}"
				alt="${colorInfo.color_name}"
				class="rounded-full border border-black"
				src="${colorInfo.color_swatch_image}"
				/>`;
			
			swatch.addEventListener("click", () => {
				card.querySelectorAll(".swatch").forEach(s => s.classList.remove("selected"));
				swatch.classList.add("selected");
				card.querySelector(".primary-img").src = primaryImage;
				card.querySelector(".hover-img").src = hoverImage;
			});
			swatchesContainer.appendChild(swatch);
	  	});
		if (!foundDefaultSwatch) {
			const firstSwatch = swatchesContainer.querySelector('.swatch');
			if (firstSwatch) {
				firstSwatch.classList.add('selected');
				if (product.availableColors && product.availableColors.length) {
					const firstAvailableColor = product.availableColors[0];
					const primaryImage = firstAvailableColor["primary_image"];
					const hoverImage = firstAvailableColor["hover_image"];
					if (primaryImage) {
						card.querySelector(".primary-img").src = primaryImage;
					}
					if (hoverImage) {	
						card.querySelector(".hover-img").src = hoverImage;
					}
				}
			}
		}
		return card;
	}

    // Render products
    function renderProducts(list, append = true, prepend = false) {
      if (!append && !prepend) grid.innerHTML = "";
	  const fragment = document.createDocumentFragment();
	  const productCards = [];
      list.forEach(product => {
    	const productCard = renderProductCard(product);
		// productCards.push(productCard);
		fragment.appendChild(productCard);
      });
	  
	  /* for (const element of productCards) {
		fragment.appendChild(element);
	  } */
	
	  styleCountEl.innerHTML = `${productCount} styles`;
	  let prevHeight=0;
	  if (prepend) {
		// const firstChildren = grid.children[0];
		console.log('before prepend');
		grid.prepend(fragment);
		console.log('after prepend');
		// const newHeight=productGrid.scrollHeight;
    	// window.scrollTo({top: 235, behavior:'auto'});
	  } else {
		console.log('before append');
		grid.append(fragment);
		console.log('after append');
	  }
    }

	// Build filters dynamically
    function buildFilters(boostResult) {
      filtersPanel.innerHTML = `<button class="filter-close close-btn p-2"></button>
		<div class="border-b -ml-2 mt-[50px] pt-4 pb-8 text-left text-xs/[12px] md:text-[13px]/[13px] uppercase">Filter</div>`;
      
	  const facetResults = [];
	  const textFacets = retrieveFacets(boostResult?.filter?.options);
	  textFacets && textFacets.length && facetResults.push(...textFacets);
	  const rangeFacets = retrieveFacets(boostResult?.facets?.range?.list);
	  rangeFacets && rangeFacets.length && facetResults.push(...rangeFacets);

	  facetResults?.forEach((facet) => {
		const availableFacet = facet?.values?.filter((facetValue) => {
		  return facetValue.doc_count > 0;
		});
		facet.values = availableFacet;
	  });

      facetResults.forEach(facet => {
        const values = facet.values;

		const section = document.createElement("div");
	    section.className = "border-b pr-2 cursor-pointer";

	    const header = document.createElement("div");
	    header.className = "flex py-5 justify-between items-center text-xs/[12px] md:text-[13px]/[13px]";
	    header.innerHTML = `<span class="uppercase">${facet.displayName}</span> <span class="toggle-icon collapsed"></span>`;
	    section.appendChild(header);

	    const content = document.createElement("div");
	    content.className = "mb-4 space-y-2 max-h-[200px] overflow-y-auto display_none";
		
		if (facet.displayName.toLowerCase() === "size") {
		  // ✅ Size filter → boxes
		  const wrapper = document.createElement("div");
		  wrapper.className = "flex flex-wrap";
		  values.forEach(v => {
		    const box = document.createElement("span");
		    box.textContent = v.key;
		    box.dataset.value = v.key;
		    box.className = `mb-4 mr-3 p-[2px] flex border border-solid border-black
				cursor-pointer text-[11px] min-w-[56px] min-h-[34px] justify-center items-center`;
			// For size filter box
			box.addEventListener("click", () => {
			  if (!selectedFilters[facet.filterOptionId]) selectedFilters[facet.filterOptionId] = [];
			  if (selectedFilters[facet.filterOptionId].includes(v.key)) {
				selectedFilters[facet.filterOptionId] = selectedFilters[facet.filterOptionId].filter(val => val !== v.key);
				// box.classList.remove("border-300", "border");
				box.classList.add("border-2");
			  } else {
				selectedFilters[facet.filterOptionId].push(v.key);
				box.classList.remove("border-2");
				// box.classList.add("border-300", "border");
			  }
			  box.classList.toggle("border-2");
			  if (!isMobile) {
				page = 1;        // ✅ refresh grid only
				firstPageNumber = 1;
				lastPageNumber = 1;
				lastPage = false;
				// grid.innerHTML = "";
				loadProducts(false, false);
			  }
			});

			// default border style
			const selectedSizes = selectedFilters[facet.filterOptionId];
			if (selectedSizes?.includes(v.key)) {
				box.classList.add("border-2");
			}
		    wrapper.appendChild(box);
		  });
		  content.appendChild(wrapper);
		} else {
		  // ✅ Other filters → checkboxes
		  values.forEach(v => {
			const selectedSizes = selectedFilters[facet.filterOptionId];
			const isChecked = selectedSizes?.includes(v.key) ? "checked" : "";
		    const swatchColor = swatchColorMap?.[v.key];
			const borderColor = !swatchColor || swatchColor?.toUpperCase() === '#FFF' || swatchColor?.toUpperCase() === '#FFFFFF'
				? 'border border-black' : '';
			let colorFilterSwatch	= '';
			let filterDisplayName = v.key;
			if (facet.displayName?.toLowerCase().includes('color')) {
				colorFilterSwatch = `<span
					class='w-4 h-4 rounded-full inline-block mr-2 ${borderColor}'
					style='background-color: ${swatchColor}'
				></span>`;
			}
			if (facet.displayName?.toLowerCase().includes('price')) {
		    	filterDisplayName = PRICE_RANGE_LABELS[v.key]
        		? PRICE_RANGE_LABELS[v.key] : '$' + v.key.replace('-', ' - $');
			}
		    const lbl = document.createElement("label");
		    lbl.className = "mb-3 mr-3 p-[2px] text-sm flex items-center text-[11px]";
		    lbl.innerHTML = `
				<input type="checkbox" class="w-[18px] h-[18px] mr-[14px]" name="${facet.filterOptionId}" value="${v.key}" ${isChecked}> 
				${colorFilterSwatch}
				${filterDisplayName}`;

			// For checkbox filters
			lbl.querySelector("input").addEventListener("change", e => {
			  if (!selectedFilters[facet.filterOptionId]) selectedFilters[facet.filterOptionId] = [];
			  if (e.target.checked) {
				selectedFilters[facet.filterOptionId].push(v.key);
			  } else {
				selectedFilters[facet.filterOptionId] = selectedFilters[facet.filterOptionId].filter(val => val !== v.key);
			  }
			  if (!isMobile) {
				page = 1;        // ✅ refresh grid only
				firstPageNumber = 1;
				lastPageNumber = 1;
				lastPage = false;
				// grid.innerHTML = "";
				loadProducts(false, false);
			  }
			});
		    content.appendChild(lbl);
		  });
		}
		
        section.appendChild(content);

        // Accordion toggle
        header.addEventListener("click", () => {
          content.classList.toggle("display_none");
          const icon = header.querySelector(".toggle-icon");
          // icon.textContent = content.classList.contains("display_none") ? "+" : "−";
		  if (content.classList.contains("display_none")) {
			icon.classList.add('collapsed');
			icon.classList.remove('expanded');
		  } else {
			icon.classList.add('expanded');
			icon.classList.remove('collapsed');
		  }
        });

        filtersPanel.appendChild(section);
      });
      // add this to align apply button at bottom bottom-[30px]
	  filtersPanel.insertAdjacentHTML('beforeend', `<div class="panel-footer absolute left-0 right-0">
			<button class="inline-block my-8 mx-auto py-[14px] px-[22px] uppercase bg-black text-xs/[12px] text-white cursor-pointer 
			min-w-[80%] display_block lg:display_none"
			id="apply-filters">VIEW ITEMS</button>
		</div>`);
	  filtersPanel.querySelector('.filter-close').addEventListener("click", () => {
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
      });
	  overlayEl.addEventListener("click", () => {
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
      });
	  filtersPanel.querySelector('#apply-filters').addEventListener("click", () => {
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
		page = 1;        // ✅ refresh grid only
		firstPageNumber = 1;
		lastPageNumber = 1;
		lastPage = false;
		loadProducts(false, false);
      });
    }

	let filtersBuilt = false; // track if filters are already built


	async function initialProductsLoad() {
		await loadProducts(false, false);
		initialLoad = false;
	} 

    // Load products from API
    async function loadProducts(append = true, prepend = false) {
      if (loading || (totalPages !== 0 && page > totalPages)) return;
	  console.log('inside loadProducts...');
      loading = true;
      /* if (!prepend) {
		loader.classList.remove("display_none");
	  } else {
		topLoader.classList.remove("display_none");
	  }	*/

      const data = await fetchProducts({ page, filters: selectedFilters, sort: selectedSort });
	  // const productCount = data?.response?.numberOfProducts;
	  if (productCount === 0) {
		loading = false;
		topLoader.classList.add("display_none");
		loader.classList.add("display_none");
		if (!append && !prepend) grid.innerHTML = "";
		styleCountEl.classList.add("display_none");
		noResultFound.classList.remove("display_none");
		return;
	  }
	  if (firstPageNumber === 1) {
		topLoader.classList.add("display_none");
	  }
	  if (lastPage) {
		loader.classList.add("display_none");
	  }

	  filterSortWrapper.classList.remove("display_none");
	  noResultFound.classList.add("display_none");
      if (!filtersBuilt) {
        buildFilters(data);
		filtersBuilt = true;
      }
	  const products = data?.products;	
	  const productIds = products?.map((prod) => `gid://shopify/Product/${prod.id}`);
	  const shopifyProducts = await shopifyGraphQL(query, { ids: productIds });
	  const mergedProducts = mergeProductProperties(products, shopifyProducts);	
	  updateURL(); 
	  window.GTMEventBus.publish(eventConstants.VIEW_COLLECTION, {products: mergedProducts, handle, query: ''});	
	  const prevScroll = window.scrollY;
  	  const prevHeight = document.body.scrollHeight;
      console.log('before renderProducts');
	  renderProducts(mergedProducts, append, prepend);
	  console.log('after renderProducts'); 
	  styleCountEl.classList.remove("display_none");
	  
	  const newHeight = document.body.scrollHeight;
	  const heightDiff = newHeight - prevHeight;
	  if (!prepend) {
		const loaderHeight = topLoader.offsetHeight - 10;
	  	// loader.classList.add("display_none");
		if (!append && page > 1 && initialLoad) {
			// Preserve scroll position after prepending
			// window.scrollTo(0, prevScroll + heightDiff);
			console.log('before scroll initialLoad');
			window.scrollTo({
				top: prevScroll + heightDiff,
				behavior: 'smooth'
			});
			console.log('after scroll initialLoad');
			// window.scrollTo(0, 0);
		}
	  } else if (prepend) {
		  const loaderHeight = topLoader.offsetHeight - 10;
		  // topLoader.classList.add("display_none");
		  // window.scrollTo(0, prevScroll + heightDiff);
		  console.log('before scroll prepend');
			window.scrollTo({
				top: prevScroll + heightDiff,
				behavior: 'smooth'
			});		  
			console.log('after scroll prepend');
	  }
	  if (!observingTopSentinel && !initialLoad) {
		setTimeout(() => {
			observingTopSentinel = true;
			topObserver.observe(topObserverEl);
		}, 500);
	  }
	  if (!observingBottomSentinel) {
		observingBottomSentinel = true;
		bottomObserver.observe(bottomObserverEl);
	  }
	  loading = false;
	  if (firstPageNumber > 1) {
		topLoader.classList.remove("display_none");
	  }
	  initializeQuickView();
    }

    // Reset and reload products
    function resetAndLoad() {
      page = 1;
	  firstPageNumber = 1;
	  lastPageNumber = 1;
      lastPage = false;
      // grid.innerHTML = "";
      loadProducts(false, false);
    }

	function updateURL() {
		const params = new URLSearchParams();
		if (Object.keys(selectedFilters).length) {
			for (const [key, values] of Object.entries(selectedFilters)) {
				values.forEach(v => params.append(key, v));
			}
		}
		if (selectedSort) params.set("sort", selectedSort);
		if (pageNoToAppend && pageNoToAppend > 1) params.set("page", pageNoToAppend);
		const query = params.toString();
		const newUrl = query ? "?" + query : location.pathname;
		history.replaceState(null, "", newUrl);
	}
	
  	function restoreFromURL() {
		const params = new URLSearchParams(window.location.search);
		selectedFilters = {};
		params.forEach((value, key) => {
			if (key === "sort") {
				selectedSort = value;
				console.log('selectedSort', selectedSort);
			} else if (key === "page") {
				page = parseInt(value) || 1;
				pageNoToAppend = page;				
				firstPageNumber = page;
				lastPageNumber = page;
			} else if (isValidFacet(key)) {
				if (!selectedFilters[key]) selectedFilters[key] = [];
				selectedFilters[key].push(value);
			}
		});
		const sortOptions = document.querySelectorAll("#sortPanel button");
		const matchingSortOption = Array.from(sortOptions).filter(srt => srt.dataset.sort === selectedSort);
		const selectedSortOption = matchingSortOption?.[0];
		sortValue.innerHTML = selectedSortOption.innerHTML;
		selectedSortOption.classList.add('selected');
	}

	let lastY = window.scrollY;
	let userHasScrolled = false;
	window.addEventListener('scroll', () => {
		const y = window.scrollY;		
		const isScrollUp = y < lastY;
		lastY = y;
		// if user scrolled up manually and they had scrolled down before, enable the top observer
		if (!userHasScrolled && !observingTopSentinel && !loading && isScrollUp) {
			userHasScrolled = true;
			observingTopSentinel = true;
			topObserver.observe(topObserverEl);
		}
	});

    // Infinite scroll
	/*let lastScrollTop = 0;
	window.addEventListener("scroll", () => {
	  const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
	  if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 && !loading && lastPageNumber < totalPages) {
		lastPageNumber++;
		page = lastPageNumber;            // ✅ increment once
		console.log('loading page ::', page);
		loadProducts(true, false);
	  }

	  // load previous page
	  let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
	  if (currentScrollTop < lastScrollTop && window.scrollY < 235 && !loading && firstPageNumber > 1) {
		firstPageNumber--;
		page = firstPageNumber;         // ✅ increment once
		console.log('loading page ::', page);
		loadProducts(false, true);
	  }
	  lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
	});*/

	window.addEventListener('resize', () => {
	  isMobile = window.innerWidth <= 1024;
	});

	const bottomObserver = new IntersectionObserver(entries => {
		for (let entry of entries) {
			const lastCard = entry;
			if (lastCard.isIntersecting && !loading && !initialLoad) {
				if (lastPageNumber < totalPages) {
					lastPageNumber++;
					page = lastPageNumber;
					// loader.classList.remove('hidden');			
					bottomObserver.unobserve(bottomObserverEl);	
					observingBottomSentinel = false;
					loadProducts(true, false);
				}
				// lastCardObserver.unobserve(lastCard.target);
			}
		}
	},
	{
		rootMargin: '100%'
	});

	const topObserver = new IntersectionObserver(entries => {
		for (let entry of entries) {
			const firstCard = entry;
			if (firstCard.isIntersecting && !loading && !initialLoad) { 
				if (firstPageNumber > 1) {
					firstPageNumber--;
					page = firstPageNumber;
					// topLoader.classList.remove('hidden');
					topObserver.unobserve(topObserverEl);
					observingTopSentinel = false;
					loadProducts(false, true);
				}
				// firstCardObserver.unobserve(firstCard.target);
			}
		}
	},
	{
		rootMargin: '100%'
	});	

    // Toggle panels
    filterToggle.addEventListener("click", () => {
      // filtersPanel.classList.toggle("display_none");
	  filtersPanel.classList.remove("translate-x-full", "md:-translate-x-full");
	  overlayEl.classList.add('active');
	  document.body.style.overflow = 'hidden';
      // sortPanel.classList.add("display_none");
	  // sortPanel.classList.add("translate-x-full", "md:-translate-x-full");
    });
    sortToggle.addEventListener("click", () => {
      //sortPanel.classList.toggle("display_none");
	  sortPanel.classList.remove("-translate-x-full", "md:translate-x-full");
      // filtersPanel.classList.add("display_none");
      // filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
	  overlayEl.classList.add('active');
	  document.body.style.overflow = 'hidden';
    });

    sortCloseBtn.addEventListener("click", () => {
      //sortPanel.classList.toggle("display_none");
	  sortPanel.classList.add("-translate-x-full", "md:translate-x-full");
      // filtersPanel.classList.add("display_none");
      // filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
	  overlayEl.classList.remove('active');
	  document.body.style.overflow = '';
    });
    // Close panels on outside click
    document.addEventListener("click", e => {
      if (!filtersPanel.contains(e.target) && !filterToggle.contains(e.target)) {
        // filtersPanel.classList.add("display_none");
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		if (!sortPanel.contains(e.target) && !sortToggle.contains(e.target)) {
			overlayEl.classList.remove('active');
			document.body.style.overflow = '';
		}
      }
      if (!sortPanel.contains(e.target) && !sortToggle.contains(e.target)) {
        // sortPanel.classList.add("display_none");
		sortPanel.classList.add("-translate-x-full", "md:translate-x-full");
		if (!filtersPanel.contains(e.target) && !filterToggle.contains(e.target)) {
			overlayEl.classList.remove('active');
			document.body.style.overflow = '';
		}
      }
    });

    // Handle sort buttons
    sortPanel.querySelectorAll("button.sort-btn").forEach(btn => {
      btn.addEventListener("click", () => {
        sortPanel.querySelectorAll("button.sort-btn").forEach(sortbtn => sortbtn.classList.remove('selected'));
		btn.classList.add('selected')
        selectedSort = btn.dataset.sort;
		sortValue.innerHTML = btn.innerHTML;
        resetAndLoad();
        // sortPanel.classList.add("display_none");
		sortPanel.classList.add("-translate-x-full", "md:translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
      });
    });

    // Initial load
	restoreFromURL();
    initialProductsLoad();
	// loadProducts(false, false);
    // topObserver.observe(topObserverEl);
	// bottomObserver.observe(bottomObserverEl);	
	// initialLoad = false;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyco-search-results-lazy-loading-v1"]) return;
  try {
    
const swatchColorMap = {
  	'BLACK': '#000000',
	'BLUE': '#0066FF',
	'BROWN': '#746155',
	'MULTICOLOR': '//images.ctfassets.net/x9pzmr4klqz6/4olle2ZxVZLxIp…Mesh-Button-Front-Shirt-Gabrielle-Union-x-FTF.png',
	'DENIM': '#6FA8DC',
	'GREEN': '#2E6930',
	'GREY': '#BDBDBD',
	'NATURAL': '#DECCA6',
	'ORANGE': '#FFA500',
	'PINK': '#FFC2CD',
	'PURPLE': '#660066',
	'RED': '#CC0000',
	'WHITE': '#FFFFFF',
	'YELLOW': '#FFE800',
};
async function shopifyGraphQL(query, variables = {}) {
	  const endpoint = "https://sg-nyandco.myshopify.com/api/2025-01/graphql.json";
	  const accessToken = "9886c5c41e8507cefb505c5f68cc4b8d";

	  const response = await fetch(endpoint, {
		method: "POST",
		headers: {
		  "Content-Type": "application/json",
		  "X-Shopify-Storefront-Access-Token": accessToken,
		},
		body: JSON.stringify({ query, variables }),
	  });

	  const result = await response.json();
	  return result.data;
  }

	const query = `
	  query getProductsByIds($ids: [ID!]!) {
		nodes(ids: $ids) {
		  ... on Product {
			id
			title
			handle
			images (first:250) {
			  edges {
				node {
				  url
				  altText
				}
			  }
			}
			media(first: 50) {
			  edges {
				node {
				  mediaContentType
				  alt
				  ...on Video {
					sources {
					  url
					  mimeType
					  format
					  height
					  width
					}
				  }
				}
			  }
			}
			compareAtPriceRange {
			  minVariantPrice {
				amount
				currencyCode
			  }
			  maxVariantPrice {
				amount
				currencyCode
			  }
			}
			priceRange {
			  minVariantPrice {
				amount
				currencyCode
			  }
			  maxVariantPrice {
				amount
				currencyCode
			  }
			}
			metafields(
			  identifiers: [
				{namespace: "product", key: "class_style_number"}
				{namespace: "product", key: "start_date"}
				{namespace: "product", key: "discount_tag"}
				{namespace: "product", key: "proportions"}
				{namespace: "custom", key: "video_autoplay"}
				{namespace: "custom", key: "video_thumbnail"}
				{namespace: "product", key: "product_class"}
				{namespace: "product", key: "product_department"}
			  ]
			) {
			  key
			  value
			}
		  }
		}
	  }
	`;
	
  const generateProductMap = (products) => {
	const productMap = {};
	products.forEach((p) => {
		const pid = p?.id?.replace('gid://shopify/Product/', '');
		productMap[pid] = p;
	})
	return productMap; 
  }  
  
  const findColorImages = (color_code, color_name, color_family, imageMap) => {
	  let swatchAltText = '#swatch_' + color_name;
	  let avAltText = '#color_' + color_name;
	  let swatchImage = imageMap?.[swatchAltText];
	  let avImages = imageMap?.[avAltText];
	  if (swatchImage || (avImages && avImages.length)) {	 
		return {
			"swatchImage" : swatchImage?.[0].url,
			"primaryImage": avImages?.[0]?.url,
			"hoverImage": avImages?.length > 1 ? avImages?.[1]?.url : avImages?.[0]?.url,
		};	  
	  }
	  swatchAltText = '#swatch_' + color_family;
	  avAltText = '#color_' + color_family;
	  swatchImage = imageMap?.[swatchAltText];
	  avImages = imageMap?.[avAltText];
	  return {
		"swatchImage" : swatchImage?.[0].url,
		"primaryImage": avImages?.[0]?.url,
		"hoverImage": avImages?.length > 1 ? avImages?.[1]?.url : avImages?.[0]?.url,
	  };
	}
  
  const mergeProductProperties = (products, shopifyProducts) => {
	const productMap = generateProductMap(shopifyProducts?.nodes);
	products?.forEach((p) => {
		const sfPrd = productMap[p.uniqueId];
		p.compareAtPriceRange = sfPrd?.compareAtPriceRange;
		p.metafields = sfPrd?.metafields;
		p.options = sfPrd?.options;
		p.priceRange = sfPrd?.priceRange;
		if (p?.relevantDocument === 'variant') {
		  const v_images = p?.variants?.[0]?.v_images?.filter(
			(v_img) => !v_img?.includes('_sw'),
		  );
		  p.v_images = v_images?.length && v_images.toReversed();
		}
		const colorImageMap = {};
		sfPrd?.images?.edges?.forEach(
			(img) => {
				if (!colorImageMap.hasOwnProperty(img?.node?.altText)) {
					colorImageMap[img?.node?.altText] = []
				}
				colorImageMap[img?.node?.altText].push(img?.node);
			}
		);
		p.availableColors = p?.variants?.map((v) => {
			const colorImages = findColorImages(
				v?.v_meta_color_code,
				v?.v_meta_color_name,
				v?.v_meta_color_family,
				colorImageMap,
			)
			return {
				color_code: v?.v_meta_color_code,
				color_family: v?.v_meta_color_family,
				color_name: v?.v_meta_color_name,
				color_swatch_image: colorImages?.["swatchImage"],
				primary_image: colorImages?.["primaryImage"],
				hover_image: colorImages?.["hoverImage"],
			}
		});
		//p.variants = sfPrd?.variants;
		p.images = sfPrd?.images;
		p.media = sfPrd?.media;
		p.id = p.uniqueId;
		
	})
	return products;
  }
  
  const getVariantMetafield = (key, entity) => {
	  const metafield = entity?.[key];
	  if (!metafield) return undefined;
	  let value = metafield;

	  // Just in case we find a list or JSON object type value, try parsing it
	  try {
		value = JSON.parse(value);
	  } catch (e) {
		// Wasn't a JSON-parseable field
	  }

	  return value;
  };
  
	const getProductMetafield = (key, entity) => {
	  const metafield = entity?.metafields?.find((mf) => mf?.key === key);
	  if (!metafield) return undefined;
	  let value = metafield.value;

	  // Just in case we find a list or JSON object type value, try parsing it
	  try {
		value = JSON.parse(value);
	  } catch (e) {
		// Wasn't a JSON-parseable field
	  }

	  return value;
	}
  
  function isNewArrival(date, daysOld = 90) {
	  return (
		new Date(date).valueOf() >
		new Date().setDate(new Date().getDate() - daysOld).valueOf()
	  );
  }
  
  const getDiscountTag = (product) => {
	const discountTag = getProductMetafield('discount_tag', product);
	let firstDiscountTag = discountTag?.[0]?.split(':')?.[1];
	return firstDiscountTag;
  }
  
  const getBadge = (product, variant) => {
	  const startDate = getProductMetafield('start_date', product);
	  const variantBadge = variant
		? getVariantBadge(variant)
		: getVariantBadge(product?.variants?.[0]);

	  let badge = '';
	  if (isNewArrival(startDate)) {
		badge = 'New';
	  }

	  if (variantBadge) {
		badge = variantBadge;
	  }

	  return badge;
  };

	const bwlDepts = [26, 27, 30, 32, 33, 34, 35, 36, 37, 38];
	function isBWLProduct(product) {
	  const prodDept = getProductMetafield('product_department', product);
	  if (bwlDepts && bwlDepts.length && bwlDepts.includes(prodDept)) {
		return true;
	  }
	  return false;
	}
	
	const getOtherProportions = (product) => {
	  const proportions = getProductMetafield('proportions', product)?.map((p, index, ds) => {
        const split = p?.split('|');
        if (split?.length > 1 && index > 0) {
          return `${split[0]} ${index < ds?.length - 1 ? ' and ' : ''}`;
        }
        return '';
      });
	  return proportions;
	}

	const getVariantBadge = (variant) => {
	  const badges = {
		NYDEAL: 'NY Deal',
		'NY Deal': 'NY Deal',
		STYLEDEAL: 'Style Deal',
		'Style Deal': 'Style Deal',
		CITYSTEAL: 'City Steal',
		'City Steal': 'City Steal',
		GREATFIND: 'Great Find',
		'Great Find': 'Great Find',
		CYBERDEAL: 'Cyber Deal',
		'Cyber Deal': 'Cyber Deal',
		PREORDER: 'PREORDER',
		'PRE ORDER': 'PREORDER',
		ALMOSTGONE: 'Almost Gone!',
		'Almost Gone': 'Almost Gone!',
		BESTSELLER: 'Best Seller',
		'Best Seller': 'Best Seller',
		BACKINSTOCK: 'Back In Stock',
		'Back In Stock': 'Back In Stock',
		NEWTOSALE: 'New to Sale',
		'New to Sale': 'New to Sale',
		PRICEDROPPED: 'Price dropped',
		'Price dropped': 'Price dropped',
		TOPRATED: 'Top Rated',
		'Top Rated': 'Top Rated',
		TRENDINGNOW: 'Trending Now',
		'Trending Now': 'Trending Now',
		INDEMAND: 'In Demand',
		'In Demand': 'In Demand',
		NYDEALS: 'NY Deals',
		'NY Deals': 'NY Deals',
		NEWCOLOR: 'New Color',
		'New Color': 'New Color',
		PLUSSIZES: 'Plus Sizes',
		'Plus Sizes': 'Plus Sizes',
		SELLINGFAST: 'Selling Fast',
		'Selling Fast': 'Selling Fast',
	  };
	  const variantBadge = getVariantMetafield('v_meta_badge', variant);
	  return badges[variantBadge];
	};
  
	const generatePriceRangeKey = (facetValues, i, gap) => {
	  const start = i == 0 ? '*' : parseInt(facetValues[i]);
	  const end = parseInt(facetValues[i]) + gap;
	  return `${start}-${end}`;
	};

	const retrieveFacets = (facetList) => {
		const filters = [];
		if (facetList && facetList.length) {
			facetList.forEach((facet) => {
			  const facetName = facet.facetName;
			  let generateKey = false;
			  let facetValues = [];
			  if (Array.isArray(facet?.values)) {
				facetValues = facet?.values;
			  } else {
				facetValues = facet?.values?.counts;
				generateKey = true;
				facet.filterField = facet.facetName;
			  }
			  if (allowedFilters?.length == 0 || allowedFilters?.indexOf(facetName) > -1) {
				const facetArray = [];
				for (let i = 0; i < facetValues?.length - 1; i = i + 2) {
				  facetArray.push({
					key: generateKey
					  ? generatePriceRangeKey(facetValues, i, facet?.values?.gap)
					  : facetValues?.[i],
					doc_count: facetValues?.[i + 1],
				  });
				}
				facet.label = netcoreApiConfig.filterNameMapping[facet.displayName];
				facet.values = facetArray;
			  }
			  filters.push(facet);
			});
		  }
		  return filters;
	};
	
  //const plpContainer = document.querySelector(".plp-container");
  const filterSortWrapper = document.querySelector("#filter-sort-wrapper");
  const noResultFound = document.querySelector("#no-result-found");
  const styleCountEl = document.querySelector("#style-count");
  const searchMessageWrapper = document.querySelector("#search-message-wrapper");
  const searchMessage = document.querySelector(".search-message");
  const grid = document.getElementById("productGrid");
  const topLoader = document.getElementById("loadingIndicatorTop");
  const loader = document.getElementById("loadingIndicatorBottom");
  const topObserverEl = document.getElementById('top-observer');
  const bottomObserverEl = document.getElementById('bottom-observer');
  const overlayEl = document.getElementById('overlay');
  const filtersPanel = document.getElementById("filtersPanel");
  const filterToggle = document.getElementById("filterToggle");
  const sortToggle = document.getElementById("sortToggle");
  const sortCloseBtn = document.querySelector(".sort-close");
  const sortPanel = document.getElementById("sortPanel");
  const sortValue = document.getElementById("selectedSort");
  
	let isMobile = window.innerWidth <= 1024;	
	let selectedFilters = {};   // e.g. { category: ["Shoes", "Shirts"], color: ["Red"] }
	let selectedSort = "";
	let page = 1;
	let firstPageNumber = 1;
	let lastPageNumber = 1;
	let loading = false;
	let lastPage = false;
	let totalPages = 0;
	let productCount = 0;
	let observingTopSentinel = false;
	let observingBottomSentinel = false;
	const pageSize = 12;
	const urlParams = new URLSearchParams(window.location.search);
	const searchQuery = urlParams.get("q");
	 
  async function fetchProducts({ page, filters, sort }) {
    const unbxdUserId = getCookie("unbxd.userId");
    const userType = getCookie('unbxd.visit');
    const params = {
      apiKey: "d81b3759fd6d2a851f3915f35feb6c67",
      siteKey: "ss-unbxd-gus-prod-Nyco32261737705692",
      q: searchQuery,
      page,
      sortBy: sort,
      collectionId: "295209566395",
      filters,
      unbxdUserId: unbxdUserId,
      userType : userType,
      userAgent : navigator.userAgent
    };
	const data = await getSearchResults(params);    
	productCount = data?.response?.numberOfProducts;	  
	const start = (page - 1) * pageSize;
	const end = start + pageSize;
	lastPage = end >= productCount;
	totalPages = (productCount % pageSize) === 0 ? productCount / pageSize : parseInt(productCount / pageSize) + 1;
	return data;      
  }

	const calculatePriceRange = (product) => {
	  	const productComparePriceMax =
			product?.compareAtPriceRange?.maxVariantPrice?.amount;
		const productComparePriceMin =
			product?.compareAtPriceRange?.minVariantPrice?.amount;

		const productPriceMin = product?.priceRange?.minVariantPrice?.amount;
		const productPriceMax = product?.priceRange?.maxVariantPrice?.amount;
		
		const firstDiscountTag = getDiscountTag(product);
		const priceMinMaxEqual = productPriceMin === productPriceMax;
		if(priceMinMaxEqual &&
			Number(productComparePriceMax) >= Number(productPriceMin)) {
		  if (Number(productComparePriceMax) === Number(productPriceMin)) {
			  return {
				  type: "list-price",
				  listPrice: Number(productComparePriceMax),
				  discountTag: firstDiscountTag
				};
			} else {
			  return {
				  type: "no-range",
				  listPrice: Number(productComparePriceMax),
				  salePrice: Number(productPriceMin),
				  discountTag: firstDiscountTag
				};
			}
		} else {
			{/* Different discounts for variants */}
			if (productPriceMin !== productPriceMax &&
			  Number(productComparePriceMax) > Number(productPriceMin)) {
				return {
				  type: "range",
				  listPrice: Number(productComparePriceMax),
				  minSalePrice: Number(productPriceMin),
				  maxSalePrice: Number(productPriceMax),
				  discountTag: firstDiscountTag
				};
			}

			{/* No discount */}
			if (Number(productComparePriceMax) < Number(productPriceMin)) {
			  if (productPriceMin !== productPriceMax) {
				  return {
					  type: "sale-price-range",
					  minSalePrice: Number(productPriceMin),
					  maxSalePrice: Number(productPriceMax),
					};
				} else {
				   return {
					  type: "list-price",
					  listPrice: Number(productPriceMin),
					  discountTag: firstDiscountTag
					};
				}
			}
		}

	  // Fallback (covers minSale == maxSale but < listPrice)
	  return {
		type: "single-sale",
		listPrice: Number(productComparePriceMax),
		salePrice: Number(productPriceMin)
	  };
	}
	
	const renderProductCard = (product) => {		
        const card = document.createElement("div");
		card.dataset.pageNo = page;
		card.id = product.id;
		const productUrl = product?.productUrl;
		const badge = getBadge(product);
		
        card.className = "overflow-hidden relative card-nyco-product";
		const badgeHtml = badge ? `<span class="absolute mt-[5px] sm:mt-2 right-[5px] sm:right-2 bg-white text-black text-[10px] sm:text-xs px-[6px] sm:px-2 py-[2px] sm:py-1 rounded-full">
						${badge}
					  </span>` : '';
		const priceRange = calculatePriceRange(product);
		const discountMsg = priceRange?.discountTag;
		const quickViewButtonMob = `<div data-quick-view 
			class="absolute z-5 right-[5px] p-[10px] bottom-1 display_block 
			lg:display_none cursor-pointer"
			data-product-handle=${product.handle}
			data-discount-tags=${JSON.stringify(discountMsg)}
			>
				<svg width="15" height="19" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M9.08345 6.0835V8.1665H10.3334V6.0835H11.6639L12.2417 14.7503C12.2897 15.4718 11.7175 16.0835 10.9944 16.0835H3.00552C2.28244 16.0835 1.71019 15.4718 1.75829 14.7503L2.33608 6.0835H3.66678V8.1665H4.91678V6.0835H9.08345ZM10.3334 4.8335H12.8333L13.4889 14.6672C13.5851 16.1102 12.4406 17.3335 10.9944 17.3335H3.00552C1.55936 17.3335 0.414858 16.1102 0.511055 14.6672L1.16664 4.8335H3.66678V3.99984C3.66678 2.15889 5.15917 0.666504 7.00012 0.666504C8.84106 0.666504 10.3334 2.15889 10.3334 3.99984V4.8335ZM4.91678 4.8335V3.99984C4.91678 2.84924 5.84952 1.9165 7.00012 1.9165C8.15071 1.9165 9.08345 2.84924 9.08345 3.99984V4.8335H4.91678Z" fill="#171011">
				</path>
				</svg>
			</div>`;	
		const quickViewButton = `<button 
			type="button"
			class="quick-view-btn absolute left-[5px] right-[5px] p-[10px] bg-white/[.9] z-10 transition-bottom ease-in-out
					delay-150 duration-[700ms] bottom-[25px] display_none lg:display_block"
			data-quick-view
			data-product-handle=${product.handle}
			data-discount-tags=${JSON.stringify(discountMsg)}
			class="underline text-sm">
			Quick View
			</button>`;	
		const bwlHtml = isBWLProduct(product) ? `<div
						class="mb-[5px] text-[10px]/[15px] uppercase text-dusty" style="letter-spacing: .02em; font-weight: 500"
					>
						Brands We Love
					</div>` : '';
		const proportions = getOtherProportions(product)?.join("");			
		const proportionHtml = proportions ? `<div
            class="mb-[2px] text-[10px]/[15px] uppercase text-dusty" style="letter-spacing: .02em; font-weight: 500"
          >
            Available in ${proportions}
          </div>` : '';	

		let discountMsgHtml = '';
		if (discountMsg && discountMsg.length) {
			discountMsgHtml = `<div
								class="mb-[5px] text-[11px]/[16px] font-semibold display_none md:inline-block" style="letter-spacing: .02em;"
							  >`;
			discountMsg.split(',').forEach((discountTag, index) => (
			  discountMsgHtml = `${discountMsgHtml}<p class="mb-0">
			    ${discountTag}
			  </p>`
		    ))
			discountMsgHtml = `${discountMsgHtml}</div>`;
		}		
		
		let priceRangeHtml = '';
		if (priceRange) {
			if (priceRange.type === 'range') {
				priceRangeHtml = `<div class="flex flex-wrap">
                  <div class="w-full flex mb-[6px]">
                    <div class="line-through">
                      $${priceRange.listPrice}
                    </div>

                    <div class="flex text-ruby ml-2">
                      $${priceRange.minSalePrice}&nbsp;
                      &#8211;&nbsp;
                      $${priceRange.maxSalePrice}
                    </div>
                  </div>
				</div>`;
			}
			else if (priceRange.type === 'list-price') {
				priceRangeHtml = `<div class="flex flex-wrap">
					${priceRange.listPrice}
				</div>`;
			}
			else if (priceRange.type === 'no-range') {
				priceRangeHtml = `<div class="flex flex-wrap">
					<div class="w-full flex mb-[6px]">
					  <div class="line-through">
						$${priceRange.listPrice}
					  </div>

					  <div class="flex text-ruby ml-2">
						$${priceRange.salePrice}
					  </div>
					</div>
				</div>`;
			}
			else if (priceRange.type === 'sale-price-range') {
				priceRangeHtml = `<div class="flex">
                    <div class="flex">
                      $${priceRange.minSalePrice}&nbsp;
                      &#8211;&nbsp;
                      $${priceRange.maxSalePrice}
                    </div>
                  </div>`;
			}			
		}
		const placeholderImage =
			'https://cdn.shopify.com/s/files/1/0554/0718/2011/files/NYCO_Placeholder_image.avif?v=1704875304';
			
		const firstImage =
		  product?.v_images && product?.v_images?.length
			? product?.v_images[0]
			: product?.images?.edges?.length > 0
			? product?.images?.edges[0]?.node?.url
			: placeholderImage;

		const videoSources =
		  product?.media?.edges?.length > 1 &&
		  product?.media?.edges[1]?.node?.mediaContentType === 'VIDEO' &&
		  product?.media?.edges[1]?.node?.sources;
		let videoUrl;
		if (videoSources?.length) {
		  const videoUrls = videoSources.filter(
			(videoSrc) => videoSrc?.format !== 'm3u8',
		  );
		  videoUrl = videoUrls?.length ? videoUrls[0].url : videoSources[0].url;
		}
	    const altImage = videoUrl
		  ? videoUrl
		  : product?.v_images && product?.v_images?.length > 1
		  ? product?.v_images[1]
		  : product?.images?.edges?.length > 1
		  ? product?.images?.edges[1]?.node?.url
		  : placeholderImage;
	  
		const mainImageHtml = `<img class="primary-img absolute inset-0 w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-0"
			src="${firstImage}" alt="${product.title}" loading="lazy" sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw">`;
		const hoverImageHtml = videoUrl ?
		`<video class="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100"
           preload="none" autoplay muted loop playsinline>
		  <source src="${videoUrl}" type="video/mp4">
		</video>`
		: `<img class="hover-img absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-300 group-hover:opacity-100" 
			src="${altImage}" alt="${product.title}" loading="lazy" sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw">`;
		<!-- old starts -->
		card.innerHTML = `
		  <div class="card-product group relative w-full aspect-[3/4] overflow-hidden">
		  
			<!-- Media wrapper wrapped with link -->
			<a class="product-link block relative w-full aspect-[3/4] overflow-hidden" href="${productUrl}">
				${mainImageHtml}
				${hoverImageHtml}
				${badgeHtml}	
			</a>
			${quickViewButtonMob}
			${quickViewButton}
		  </div>
          <div class="px-1 sm:px-2 md:px-3 lg:px-4 py-3">
			<div class="swatches flex mb-2"></div>
			${bwlHtml}
			${proportionHtml}
            <a class="product-link block product-title" href="${productUrl}">
			  <h3 class="text-sm font-semibold">${product.title}</h3>
			</a>	
			${discountMsgHtml}
            <div class="text-black-500 text-sm font-medium product-price">${priceRangeHtml}</div>
          </div>`;

		card.querySelectorAll(".product-link").forEach(prodLinkEl => prodLinkEl.addEventListener('click', () => updateURL(card.dataset.pageNo)))  
		// Swatches
		const swatchesContainer = card.querySelector(".swatches");
		product.availableColors.forEach((colorInfo, i) => {
			const swatch = document.createElement("button");
			const primaryImage = colorInfo?.["primary_image"];
			const hoverImage = colorInfo?.["hover_image"];
			const isSelected = firstImage === primaryImage || firstImage === hoverImage 
				|| altImage === primaryImage || altImage === hoverImage 
			swatch.className = "rounded-full swatch" + (isSelected ? " selected" : "");
			swatch.innerHTML = `<img
				width="18"
				height="18"
				title="${colorInfo.color_name}"
				alt="${colorInfo.color_name}"
				class="rounded-full border border-black"
				src="${colorInfo.color_swatch_image}"
				/>`;
			swatch.addEventListener("click", () => {
				card.querySelectorAll(".swatch").forEach(s => s.classList.remove("selected"));
				swatch.classList.add("selected");
				card.querySelector(".primary-img").src = primaryImage;
				card.querySelector(".hover-img").src = hoverImage;
			});
			swatchesContainer.appendChild(swatch);
	  	});
		return card;
	}

    // Render products
    function renderProducts(list, append = true, prepend = false) {
      if (!append && !prepend) grid.innerHTML = "";
	  const productCards = [];
      list.forEach(product => {
      	const productCard = renderProductCard(product);
		productCards.push(productCard);
      });
	  const fragment = document.createDocumentFragment();
	  for (const element of productCards) {
		fragment.appendChild(element);
	  }

	  styleCountEl.innerHTML = `${productCount} styles`;
	  let prevHeight=0;
	  if (prepend) {
		const firstChildren = grid.children[0];
		grid.insertBefore(fragment, firstChildren);
		// const newHeight=productGrid.scrollHeight;
    	// window.scrollTo({top: 235, behavior:'auto'});
	  } else {
		grid.append(fragment);
	  }
    }

    // Build filters dynamically
    function buildFilters(netcoreResult) {
      filtersPanel.innerHTML = `<button class="filter-close close-btn p-2"></button>
		<div class="border-b -ml-2 mt-[50px] pb-8 text-left text-xs/[12px] uppercase">Filter</div>`;
      
	  const facetResults = [];
	  const textFacets = retrieveFacets(netcoreResult?.facets?.text?.list);
	  textFacets && textFacets.length && facetResults.push(...textFacets);
	  const rangeFacets = retrieveFacets(netcoreResult?.facets?.range?.list);
	  rangeFacets && rangeFacets.length && facetResults.push(...rangeFacets);

	  facetResults?.forEach((facet) => {
		const availableFacet = facet?.values?.filter((facetValue) => {
		  return facetValue.doc_count > 0;
		});
		facet.values = availableFacet;
	  });

      facetResults.forEach(facet => {
        const values = facet.values;
		
		const section = document.createElement("div");
	    section.className = "border-b py-5 pr-2";

	    const header = document.createElement("div");
	    header.className = "flex justify-between items-center cursor-pointer text-xs/[12px]";
	    header.innerHTML = `<span class="uppercase">${facet.displayName}</span> <span class="toggle-icon collapsed"></span>`;
	    section.appendChild(header);

	    const content = document.createElement("div");
	    content.className = "mt-4 space-y-2 max-h-[200px] overflow-y-auto display_none";
		
		if (facet.displayName.toLowerCase() === "size") {
		  // ✅ Size filter → boxes
		  const wrapper = document.createElement("div");
		  wrapper.className = "flex flex-wrap";
		  values.forEach(v => {
		    const box = document.createElement("span");
		    box.textContent = v.key;
		    box.dataset.value = v.key;
		    box.className = `mb-4 mr-3 p-[2px] flex border border-solid border-black
				cursor-pointer text-[11px] min-w-[56px] min-h-[34px] justify-center items-center`;
			// For size filter box
			box.addEventListener("click", () => {
			  if (!selectedFilters[facet.filterField]) selectedFilters[facet.filterField] = [];
			  if (selectedFilters[facet.filterField].includes(v.key)) {
				selectedFilters[facet.filterField] = selectedFilters[facet.filterField].filter(val => val !== v.key);
				// box.classList.remove("border-300", "border");
				box.classList.add("border-2");
			  } else {
				selectedFilters[facet.filterField].push(v.key);
				box.classList.remove("border-2");
				// box.classList.add("border-300", "border");
			  }
			  box.classList.toggle("border-2");
			  if (!isMobile) {
				page = 1;        // ✅ refresh grid only
				firstPageNumber = 1;
				lastPageNumber = 1;
				lastPage = false;
				// grid.innerHTML = "";
				loadProducts(false, false);
			  }
			});

		    // default border style
			const selectedSizes = selectedFilters[facet.filterField];
			if (selectedSizes?.includes(v.key)) {
				box.classList.add("border-2");
			}
		    wrapper.appendChild(box);
		  });
		  content.appendChild(wrapper);
		} else {
		  // ✅ Other filters → checkboxes
		  values.forEach(v => {
			const selectedSizes = selectedFilters[facet.filterField];
			const isChecked = selectedSizes?.includes(v.key) ? "checked" : "";
		    const swatchColor = swatchColorMap?.[v.key];
			const borderColor = (swatchColor?.toUpperCase() === 'FFF' || swatchColor?.toUpperCase() === 'FFFFFF')
				? 'border border-black' : '';
			let colorFilterSwatch	= '';
			if (facet.displayName?.toLowerCase().includes('color')) {
				colorFilterSwatch = `<span
					class='w-4 h-4 rounded-full inline-block mr-2 ${borderColor}')}
					style='background-color: ${swatchColor}'
				></span>`;
			}
		    const lbl = document.createElement("label");
		    lbl.className = "mb-3 mr-3 p-[2px] text-sm flex items-center text-[11px]";
		    lbl.innerHTML = `
				<input type="checkbox" class="w-[18px] h-[18px] mr-[14px]" name="${facet.filterField}" value="${v.key}" ${isChecked}> 
				${colorFilterSwatch}
				${v.key}`;
			// For checkbox filters
			lbl.querySelector("input").addEventListener("change", e => {
			  if (!selectedFilters[facet.filterField]) selectedFilters[facet.filterField] = [];
			  if (e.target.checked) {
				selectedFilters[facet.filterField].push(v.key);
			  } else {
				selectedFilters[facet.filterField] = selectedFilters[facet.filterField].filter(val => val !== v.key);
			  }
			  if (!isMobile) {
				page = 1;        // ✅ refresh grid only
				firstPageNumber = 1;
				lastPageNumber = 1;
				lastPage = false;
				// grid.innerHTML = "";
				loadProducts(false, false);
			  }
			});
		    content.appendChild(lbl);
		  });
		}
		
        section.appendChild(content);

        // Accordion toggle
        header.addEventListener("click", () => {
          content.classList.toggle("display_none");
          const icon = header.querySelector(".toggle-icon");
          // icon.textContent = content.classList.contains("display_none") ? "+" : "−";
		  if (content.classList.contains("display_none")) {
			icon.classList.add('collapsed');
			icon.classList.remove('expanded');
		  } else {
			icon.classList.add('expanded');
			icon.classList.remove('collapsed');
		  }
        });

        filtersPanel.appendChild(section);
      });
      // add this to align apply button at bottom bottom-[30px]
	  filtersPanel.insertAdjacentHTML('beforeend', `<div class="panel-footer absolute left-0 right-0">
			<button class="inline-block my-8 mx-auto py-[14px] px-[22px] uppercase bg-black text-xs/[12px] text-white cursor-pointer 
			min-w-[80%] display_block lg:display_none"
			id="apply-filters">VIEW ITEMS</button>
		</div>`);
	  filtersPanel.querySelector('.filter-close').addEventListener("click", () => {
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
      });
	  overlayEl.addEventListener("click", () => {
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
      });
	  filtersPanel.querySelector('#apply-filters').addEventListener("click", () => {
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
		page = 1;        // ✅ refresh grid only
		firstPageNumber = 1;
		lastPageNumber = 1;
		lastPage = false;
		loadProducts(false, false);
      });
    }

	let filtersBuilt = false; // track if filters are already built

    // Load products from API
    async function loadProducts(append = true, prepend = false) {
      if (loading || (totalPages !== 0 && page > totalPages)) return;
      loading = true;
      if (!prepend) {
		loader.classList.remove("display_none");
	  } else {
		topLoader.classList.remove("display_none");
	  }	

      const data = await fetchProducts({ page, filters: selectedFilters, sort: selectedSort });
	  
	  // const productCount = data?.response?.numberOfProducts;
	  searchMessage.innerHTML = `Viewing ${productCount} results for '${searchQuery}'`;
	  searchMessageWrapper.classList.remove("display_none");
	  if (productCount === 0) {
		loading = false;
		loader.classList.add("display_none");
		if (!append && !prepend) grid.innerHTML = "";
		styleCountEl.classList.add("display_none");
		noResultFound.classList.remove("display_none");
		return;
	  }
	  filterSortWrapper.classList.remove("display_none");
	  noResultFound.classList.add("display_none");
      if (!filtersBuilt) {
        buildFilters(data);
		filtersBuilt = true;
      }
	  const products = data?.response?.products;	
	  const productIds = products?.map((prod) => `gid://shopify/Product/${prod.uniqueId}`);
	  const shopifyProducts = await shopifyGraphQL(query, { ids: productIds });
	  const mergedProducts = mergeProductProperties(products, shopifyProducts);	
	  updateURL(page); 
	  	
	  const prevScroll = window.scrollY;
  	  const prevHeight = document.body.scrollHeight;

      renderProducts(mergedProducts, append, prepend);
	  styleCountEl.classList.remove("display_none");

	  const newHeight = document.body.scrollHeight;
	  const heightDiff = newHeight - prevHeight;	  
	  if (!prepend) {
	  	const loaderHeight = topLoader.offsetHeight - 10;
		loader.classList.add("display_none");
		if (!append && page > 1) {
			// Preserve scroll position after prepending
			// window.scrollTo(0, prevScroll + heightDiff);
			window.scrollTo({
				top: prevScroll + heightDiff,
				behavior: 'smooth'
			});
		}		
	  } else if (prepend) {
		  const loaderHeight = topLoader.offsetHeight - 10;
		  topLoader.classList.add("display_none");
		  // window.scrollTo(0, prevScroll + heightDiff);		  
			window.scrollTo({
				top: prevScroll + heightDiff,
				behavior: 'smooth'
			});		  
	  }
	  if (!observingTopSentinel) {
		setTimeout(() => {
			observingTopSentinel = true;
			topObserver.observe(topObserverEl);
		}, 500);
	  }
	  if (!observingBottomSentinel) {
		observingBottomSentinel = true;
		bottomObserver.observe(bottomObserverEl);
	  }
	  loading = false;
	  initializeQuickView();
    }

    // Reset and reload products
    function resetAndLoad() {
      page = 1;
	  firstPageNumber = 1;
	  lastPageNumber = 1;
      lastPage = false;
      // grid.innerHTML = "";
      loadProducts(false, false);
    }

	function updateURL(pageNo) {
		const params = new URLSearchParams();
    	params.set("q", searchQuery);
		if (Object.keys(selectedFilters).length) {
		  for (const [key, values] of Object.entries(selectedFilters)) {
			  values.forEach(v => params.append(key, v));
		  }
		}
		if (selectedSort) params.set("sort", selectedSort);
		if (pageNo > 1) params.set("page", pageNo);
		const query = params.toString();
		const newUrl = query ? "?" + query : location.pathname;
		history.replaceState(null, "", newUrl);
	}
	
  	function restoreFromURL() {
		const params = new URLSearchParams(window.location.search);

		selectedFilters = {};
		params.forEach((value, key) => {
			if (key === "sort") {
				selectedSort = value;
				console.log('selectedSort', selectedSort);				
			} else if (key === "page") {
				page = parseInt(value) || 1;
				firstPageNumber = page;
				lastPageNumber = page;
			} else if (isValidFacet(key)) {
				if (!selectedFilters[key]) selectedFilters[key] = [];
				selectedFilters[key].push(value);
			}
		});
		const sortOptions = document.querySelectorAll("#sortPanel button");
		const matchingSortOption = Array.from(sortOptions).filter(srt => srt.dataset.sort === selectedSort);
		const selectedSortOption = matchingSortOption?.[0];
		sortValue.innerHTML = selectedSortOption.innerHTML;
		selectedSortOption.classList.add('selected');
	}
    // Infinite scroll
	/* let lastScrollTop = 0;
	window.addEventListener("scroll", () => {
	  const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
	  if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 && !loading && lastPageNumber < totalPages) {
		lastPageNumber++;
		page = lastPageNumber;            // ✅ increment once
		console.log('loading page ::', page);
		loadProducts(true, false);
	  }

	  // load previous page
	  let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
	  if (currentScrollTop < lastScrollTop && window.scrollY < 235 && !loading && firstPageNumber > 1) {
		firstPageNumber--;
		page = firstPageNumber;         // ✅ increment once
		console.log('loading page ::', page);
		loadProducts(false, true);
	  }
	  lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
	}); */

	window.addEventListener('resize', () => {
	  isMobile = window.innerWidth <= 1024;
	});

	const bottomObserver = new IntersectionObserver(entries => {
		for (let entry of entries) {
			const lastCard = entry;
			if (lastCard.isIntersecting) {
				if (lastPageNumber < totalPages) {
					lastPageNumber++;
					page = lastPageNumber;
					// loader.classList.remove('hidden');			
					bottomObserver.unobserve(bottomObserverEl);	
					observingBottomSentinel = false;
					loadProducts(true, false);
				}
				// lastCardObserver.unobserve(lastCard.target);
			}
		}
	},
	{
		root: null,
		rootMargin: '200px',
		threshold: 0.5
	});

	const topObserver = new IntersectionObserver(entries => {
		for (let entry of entries) {
			const firstCard = entry;
			if (firstCard.isIntersecting && !loading) { 
				if (firstPageNumber > 1) {
					firstPageNumber--;
					page = firstPageNumber;
					// topLoader.classList.remove('hidden');
					topObserver.unobserve(topObserverEl);
					observingTopSentinel = false;
					loadProducts(false, true);
				}
				// firstCardObserver.unobserve(firstCard.target);
			}
		}
	},
	{
		root: null,
		rootMargin: '200px',
		threshold: 0.5
	});		

    // Toggle panels
    filterToggle.addEventListener("click", () => {
      // filtersPanel.classList.toggle("display_none");
	  filtersPanel.classList.remove("translate-x-full", "md:-translate-x-full");
	  overlayEl.classList.add('active');
	  document.body.style.overflow = 'hidden';
      // sortPanel.classList.add("display_none");
	  // sortPanel.classList.add("translate-x-full", "md:-translate-x-full");
	});
    sortToggle.addEventListener("click", () => {
      //sortPanel.classList.toggle("display_none");
	  sortPanel.classList.remove("-translate-x-full", "md:translate-x-full");
      // filtersPanel.classList.add("display_none");
      // filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
	  overlayEl.classList.add('active');
	  document.body.style.overflow = 'hidden';
    });

	sortCloseBtn.addEventListener("click", () => {
      //sortPanel.classList.toggle("display_none");
	  sortPanel.classList.add("-translate-x-full", "md:translate-x-full");
      // filtersPanel.classList.add("display_none");
      // filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
	  overlayEl.classList.remove('active');
	  document.body.style.overflow = '';
    });
    // Close panels on outside click
    document.addEventListener("click", e => {
      if (!filtersPanel.contains(e.target) && !filterToggle.contains(e.target)) {
        // filtersPanel.classList.add("display_none");
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		if (!sortPanel.contains(e.target) && !sortToggle.contains(e.target)) {
			overlayEl.classList.remove('active');
			document.body.style.overflow = '';
		}
      }
      if (!sortPanel.contains(e.target) && !sortToggle.contains(e.target)) {
        // sortPanel.classList.add("display_none");
		sortPanel.classList.add("-translate-x-full", "md:translate-x-full");
		if (!filtersPanel.contains(e.target) && !filterToggle.contains(e.target)) {
			overlayEl.classList.remove('active');
			document.body.style.overflow = '';
		}
      }
    });

    // Handle sort buttons
    sortPanel.querySelectorAll("button.sort-btn").forEach(btn => {
      btn.addEventListener("click", () => {
		sortPanel.querySelectorAll("button.sort-btn").forEach(sortbtn => sortbtn.classList.remove('selected'));
		btn.classList.add('selected')
        selectedSort = btn.dataset.sort;
		sortValue.innerHTML = btn.innerHTML;
        resetAndLoad();
        // sortPanel.classList.add("display_none");
		sortPanel.classList.add("-translate-x-full", "md:translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
      });
    });

    // Initial load
	restoreFromURL();
    // topObserver.observe(topObserverEl);
	// bottomObserver.observe(bottomObserverEl);	
    loadProducts(false, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nyco-search-results"]) return;
  try {
    
const PRICE_RANGE_LABELS = {
    '*-10': '$10 or less',
    '*-25': '$25 or less',
    '10-25': '$10 - $25',
    '25-50': '$25 - $50',
    '50-75': '$50 - $75',
    '75-100': '$75 - $100',
    '100-125': '$100 - $125',
    '125-150': '$125 - $150',
    '150-175': '$150 - $175',
    '175-200': '$175 - $200',
    '200-225': '$200 - $225',
    '225-250': '$225 - $250',
    '250-275': '$250 - $275',
    '275-300': '$275 - $300',
    '300-325': '$300 - $325',
    '325-350': '$325 - $350',
    '350-375': '$350 - $375',
    '375-400': '$375 - $400',
  };
const swatchColorMap = {
  	'BLACK': '#000000',
	'BLUE': '#0066FF',
	'BROWN': '#746155',
	'MULTICOLOR': '//images.ctfassets.net/x9pzmr4klqz6/4olle2ZxVZLxIp…Mesh-Button-Front-Shirt-Gabrielle-Union-x-FTF.png',
	'DENIM': '#6FA8DC',
	'GREEN': '#2E6930',
	'GREY': '#BDBDBD',
	'NATURAL': '#DECCA6',
	'ORANGE': '#FFA500',
	'PINK': '#FFC2CD',
	'PURPLE': '#660066',
	'RED': '#CC0000',
	'WHITE': '#FFFFFF',
	'YELLOW': '#FFE800',
};
async function shopifyGraphQL(query, variables = {}) {
	  const endpoint = "https://sg-nyandco.myshopify.com/api/2025-01/graphql.json";
	  const accessToken = "9886c5c41e8507cefb505c5f68cc4b8d";

	  const response = await fetch(endpoint, {
		method: "POST",
		headers: {
		  "Content-Type": "application/json",
		  "X-Shopify-Storefront-Access-Token": accessToken,
		},
		body: JSON.stringify({ query, variables }),
	  });

	  const result = await response.json();
	  return result.data;
  }

	const query = `
	  query getProductsByIds($ids: [ID!]!) {
		nodes(ids: $ids) {
		  ... on Product {
			id
			title
			handle
			images (first:250) {
			  edges {
				node {
				  url
				  altText
				}
			  }
			}
			media(first: 50) {
			  edges {
				node {
				  mediaContentType
				  alt
				  ...on Video {
					sources {
					  url
					  mimeType
					  format
					  height
					  width
					}
				  }
				}
			  }
			}
			compareAtPriceRange {
			  minVariantPrice {
				amount
				currencyCode
			  }
			  maxVariantPrice {
				amount
				currencyCode
			  }
			}
			priceRange {
			  minVariantPrice {
				amount
				currencyCode
			  }
			  maxVariantPrice {
				amount
				currencyCode
			  }
			}
			variants(first: 1) {
				nodes {
					id
					sku
					title
					metafields(
						identifiers: [
							{namespace: "variant", key: "sale_tag"}
							{namespace: "variant", key: "badge"}
						]
					) {
						key
						value
					}
				}
			}
			metafields(
			  identifiers: [
				{namespace: "product", key: "class_style_number"}
				{namespace: "product", key: "start_date"}
				{namespace: "product", key: "discount_tag"}
				{namespace: "product", key: "proportions"}
				{namespace: "custom", key: "video_autoplay"}
				{namespace: "custom", key: "video_thumbnail"}
				{namespace: "product", key: "product_class"}
				{namespace: "product", key: "product_department"}
				{namespace: "product", key: "product_division"}
			  ]
			) {
			  key
			  value
			}
		  }
		}
	  }
	`;
	
  const generateProductMap = (products) => {
	const productMap = {};
	products.forEach((p) => {
		const pid = p?.id?.replace('gid://shopify/Product/', '');
		productMap[pid] = p;
	})
	return productMap; 
  }  
  
  const findColorImages = (color_name, color_family, imageMap) => {
	  let swatchAltText = '#swatch_' + color_name;
	  let avAltText = '#color_' + color_name;
	  let swatchImage = imageMap?.[swatchAltText];
	  let avImages = imageMap?.[avAltText];
	  if (swatchImage || (avImages && avImages.length)) {	 
		return {
			"swatchImage" : swatchImage?.[0].url,
			"primaryImage": avImages?.[0]?.url,
			"hoverImage": avImages?.length > 1 ? avImages?.[1]?.url : avImages?.[0]?.url,
		};	  
	  }
	  swatchAltText = '#swatch_' + color_family;
	  avAltText = '#color_' + color_family;
	  swatchImage = imageMap?.[swatchAltText];
	  avImages = imageMap?.[avAltText];
	  return {
		"swatchImage" : swatchImage?.[0].url,
		"primaryImage": avImages?.[0]?.url,
		"hoverImage": avImages?.length > 1 ? avImages?.[1]?.url : avImages?.[0]?.url,
	  };
	}
  
  const mergeProductProperties = (products, shopifyProducts) => {
	const productMap = generateProductMap(shopifyProducts?.nodes);
	products?.forEach((p) => {
		const sfPrd = productMap[p.id];
		p.compareAtPriceRange = sfPrd?.compareAtPriceRange;
		p.metafields = sfPrd?.metafields;
		p.options = sfPrd?.options;
		p.priceRange = sfPrd?.priceRange;
		if (p?.relevantDocument === 'variant') {
		  const v_images = p?.variants?.[0]?.v_images?.filter(
			(v_img) => !v_img?.includes('_sw'),
		  );
		  p.v_images = v_images?.length && v_images.toReversed();
		}
		const colorImageMap = {};
		sfPrd?.images?.edges?.forEach(
			(img) => {
				if (!colorImageMap.hasOwnProperty(img?.node?.altText)) {
					colorImageMap[img?.node?.altText] = []
				}
				colorImageMap[img?.node?.altText].push(img?.node);
			}
		);
		const availableColorInfos = getAvailableColors(p);
		p.availableColors = availableColorInfos?.map((colorInfo) => {
			const colorImages = findColorImages(
				colorInfo?.color_name,
				colorInfo?.color_family,
				colorImageMap,
			)
			return {
				color_family: colorInfo?.color_family,
				color_name: colorInfo?.color_name,
				color_swatch_image: colorImages?.["swatchImage"],
				primary_image: colorImages?.["primaryImage"],
				hover_image: colorImages?.["hoverImage"],
			}
		});
		p.shopify_variants = sfPrd?.variants;
		p.images = sfPrd?.images;
		p.media = sfPrd?.media;
		// p.id = p.id;
		p.product_department = getMetafield('product_department', sfPrd);
		p.product_class = getMetafield('product_class', sfPrd);
		p.product_division = getMetafield('product_division', sfPrd);
	})
	return products;
  }
  
  const getVariantMetafield = (key, entity) => {
	  const metafield = entity?.[key];
	  if (!metafield) return undefined;
	  let value = metafield;

	  // Just in case we find a list or JSON object type value, try parsing it
	  try {
		value = JSON.parse(value);
	  } catch (e) {
		// Wasn't a JSON-parseable field
	  }

	  return value;
  };
  
	const getMetafield = (key, entity) => {
	  const metafield = entity?.metafields?.find((mf) => mf?.key === key);
	  if (!metafield) return undefined;
	  let value = metafield.value;

	  // Just in case we find a list or JSON object type value, try parsing it
	  try {
		value = JSON.parse(value);
	  } catch (e) {
		// Wasn't a JSON-parseable field
	  }

	  return value;
	}
  
  function isNewArrival(date, daysOld = 90) {
	  return (
		new Date(date).valueOf() >
		new Date().setDate(new Date().getDate() - daysOld).valueOf()
	  );
  }
  
  const getDiscountTag = (product) => {
	const discountTag = getMetafield('discount_tag', product);
	let firstDiscountTag = discountTag?.[0]?.split(':')?.[1];
	return firstDiscountTag;
  }
  
  const getBadge = (product, variant) => {
	  const startDate = getMetafield('start_date', product);
	  const variantBadge = variant
		? getVariantBadge(variant)
		: getVariantBadge(product?.shopify_variants?.nodes?.[0]);

	  let badge = '';
	  if (isNewArrival(startDate)) {
		badge = 'New';
	  }

	  if (variantBadge) {
		badge = variantBadge;
	  }

	  return badge;
  };

	const bwlDepts = [26, 27, 30, 32, 33, 34, 35, 36, 37, 38];
	function isBWLProduct(product) {
	  const prodDept = getMetafield('product_department', product);
	  if (bwlDepts && bwlDepts.length && bwlDepts.includes(prodDept)) {
		return true;
	  }
	  return false;
	}
	
	const getOtherProportions = (product) => {
	  const proportions = getMetafield('proportions', product)?.map((p, index, ds) => {
        const split = p?.split('|');
        if (split?.length > 1 && index > 0) {
          return `${split[0]} ${index < ds?.length - 1 ? ' and ' : ''}`;
        }
        return '';
      });
	  return proportions;
	}

	const getVariantBadge = (variant) => {
	  const badges = {
		NYDEAL: 'NY Deal',
		'NY Deal': 'NY Deal',
		STYLEDEAL: 'Style Deal',
		'Style Deal': 'Style Deal',
		CITYSTEAL: 'City Steal',
		'City Steal': 'City Steal',
		GREATFIND: 'Great Find',
		'Great Find': 'Great Find',
		CYBERDEAL: 'Cyber Deal',
		'Cyber Deal': 'Cyber Deal',
		PREORDER: 'PREORDER',
		'PRE ORDER': 'PREORDER',
		ALMOSTGONE: 'Almost Gone!',
		'Almost Gone': 'Almost Gone!',
		BESTSELLER: 'Best Seller',
		'Best Seller': 'Best Seller',
		BACKINSTOCK: 'Back In Stock',
		'Back In Stock': 'Back In Stock',
		NEWTOSALE: 'New to Sale',
		'New to Sale': 'New to Sale',
		PRICEDROPPED: 'Price dropped',
		'Price dropped': 'Price dropped',
		TOPRATED: 'Top Rated',
		'Top Rated': 'Top Rated',
		TRENDINGNOW: 'Trending Now',
		'Trending Now': 'Trending Now',
		INDEMAND: 'In Demand',
		'In Demand': 'In Demand',
		NYDEALS: 'NY Deals',
		'NY Deals': 'NY Deals',
		NEWCOLOR: 'New Color',
		'New Color': 'New Color',
		PLUSSIZES: 'Plus Sizes',
		'Plus Sizes': 'Plus Sizes',
		SELLINGFAST: 'Selling Fast',
		'Selling Fast': 'Selling Fast',
	  };
	  const variantBadge = getMetafield('badge', variant);
	  return badges[variantBadge];
	};
  
	const generatePriceRangeKey = (facetValues, i, gap) => {
	  const start = i == 0 ? '*' : parseInt(facetValues[i]);
	  const end = parseInt(facetValues[i]) + gap;
	  return `${start}-${end}`;
	};

	const retrieveFacets = (facetList) => {
		const filters = [];
		if (facetList && facetList.length) {
			facetList.forEach((facet) => {
			  const facetName = facet.label;
			  let generateKey = false;
			  let facetValues = [];
			  if (Array.isArray(facet?.values)) {
				facetValues = facet?.values;
			  } else {
				facetValues = facet?.values?.counts;
				generateKey = true;
				facet.filterField = facet.label;
			  }
			  if (allowedFilters?.length == 0 || allowedFilters?.indexOf(label) > -1) {
				const facetArray = [];
				for (let i = 0; i < facetValues?.length - 1; i = i + 2) {
				  facetArray.push({
					key: generateKey
					  ? generatePriceRangeKey(facetValues, i, facet?.values?.gap || 10)
					  : facetValues?.[i],
					doc_count: facetValues?.[i + 1],
				  });
				}
				facet.displayName = facet.label;
				facet.values = facetValues;
			  }
			  filters.push(facet);
			});
		  }
		  return filters;
	};
	
  //const plpContainer = document.querySelector(".plp-container");
  const filterSortWrapper = document.querySelector("#filter-sort-wrapper");
  const noResultFound = document.querySelector("#no-result-found");
  const styleCountEl = document.querySelector("#style-count");
  const searchMessageWrapper = document.querySelector("#search-message-wrapper");
  const searchMessage = document.querySelector(".search-message");
  const grid = document.getElementById("productGrid");
  const topLoader = document.getElementById("loadingIndicatorTop");
  const loader = document.getElementById("loadingIndicatorBottom");
  const topObserverEl = document.getElementById('loadingIndicatorTop');
  const bottomObserverEl = document.getElementById('loadingIndicatorBottom');
  const overlayEl = document.getElementById('overlay');
  const filtersPanel = document.getElementById("filtersPanel");
  const filterToggle = document.getElementById("filterToggle");
  const sortToggle = document.getElementById("sortToggle");
  const sortCloseBtn = document.querySelector(".sort-close");
  const sortPanel = document.getElementById("sortPanel");
  const sortValue = document.getElementById("selectedSort");
  
	let isMobile = window.innerWidth <= 1024;	
	let selectedFilters = {};   // e.g. { category: ["Shoes", "Shirts"], color: ["Red"] }
	let selectedSort = "";
	let pageNoToAppend;
	let page = 1;
	let firstPageNumber = 1;
	let lastPageNumber = 1;
    let initialLoad = true;
	let loading = false;
	let lastPage = false;
	let totalPages = 0;
	let productCount = 0;
	let observingTopSentinel = false;
	let observingBottomSentinel = false;
	const pageSize = 12;
	const urlParams = new URLSearchParams(window.location.search);
	const searchQuery = urlParams.get("q");
	 
  async function fetchProducts({ page, filters, sort }) {
    const params = {
      q: searchQuery,
      page,
      sortBy: sort,
      filters,
      userAgent : navigator.userAgent
    };
	const data = await getSearchResults(params);    
	productCount = data?.total_product;	  
	const start = (page - 1) * pageSize;
	const end = start + pageSize;
	lastPage = end >= productCount;
	totalPages = (productCount % pageSize) === 0 ? productCount / pageSize : parseInt(productCount / pageSize) + 1;
	return data;      
  }

	const calculatePriceRange = (product) => {
	  	const productComparePriceMax =
			product?.compareAtPriceRange?.maxVariantPrice?.amount;
		const productComparePriceMin =
			product?.compareAtPriceRange?.minVariantPrice?.amount;

		const productPriceMin = product?.priceRange?.minVariantPrice?.amount;
		const productPriceMax = product?.priceRange?.maxVariantPrice?.amount;
		
		const firstDiscountTag = getDiscountTag(product);
		const priceMinMaxEqual = productPriceMin === productPriceMax;
		if(priceMinMaxEqual &&
			Number(productComparePriceMax) >= Number(productPriceMin)) {
		  if (Number(productComparePriceMax) === Number(productPriceMin)) {
			  return {
				  type: "list-price",
				  listPrice: Number(productComparePriceMax),
				  priceForGTM: Number(productComparePriceMax),
				  discountTag: firstDiscountTag
				};
			} else {
			  return {
				  type: "no-range",
				  listPrice: Number(productComparePriceMax),
				  salePrice: Number(productPriceMin),
				  priceForGTM: Number(productPriceMin),
				  discountTag: firstDiscountTag
				};
			}
		} else {
			{/* Different discounts for variants */}
			if (productPriceMin !== productPriceMax &&
			  Number(productComparePriceMax) > Number(productPriceMin)) {
				return {
				  type: "range",
				  listPrice: Number(productComparePriceMax),
				  minSalePrice: Number(productPriceMin),
				  maxSalePrice: Number(productPriceMax),
				  priceForGTM: Number(productPriceMin),
				  discountTag: firstDiscountTag
				};
			}

			{/* No discount */}
			if (Number(productComparePriceMax) < Number(productPriceMin)) {
			  if (productPriceMin !== productPriceMax) {
				  return {
					  type: "sale-price-range",
					  minSalePrice: Number(productPriceMin),
					  maxSalePrice: Number(productPriceMax),
					  priceForGTM: Number(productPriceMin),
					};
				} else {
				   return {
					  type: "list-price",
					  listPrice: Number(productPriceMin),
					  priceForGTM: Number(productPriceMin),
					  discountTag: firstDiscountTag
					};
				}
			}
		}

	  // Fallback (covers minSale == maxSale but < listPrice)
	  return {
		type: "single-sale",
		listPrice: Number(productComparePriceMax),
		salePrice: Number(productPriceMin),
		priceForGTM: Number(productPriceMin),
	  };
	}
	
	const renderProductCard = (product) => {		
        const card = document.createElement("div");
		card.dataset.pageNo = page;
		card.id = product.id;
		const productUrl = `/products/${product?.handle}`;
		const badge = getBadge(product);
		
        card.className = "overflow-hidden relative card-nyco-product";
		const badgeHtml = badge ? `<span class="absolute mt-[5px] sm:mt-2 right-[5px] sm:right-2 bg-white text-black text-[10px] sm:text-xs px-[6px] sm:px-2 py-[2px] sm:py-1 rounded-full">
						${badge}
					  </span>` : '';
		const priceRange = calculatePriceRange(product);
		const discountMsg = priceRange?.discountTag;
		
		const bwlHtml = isBWLProduct(product) ? `<div
						class="mb-[5px] text-[10px]/[15px] uppercase text-dusty" style="letter-spacing: .02em; font-weight: 500"
					>
						Brands We Love
					</div>` : '';
		const proportions = getOtherProportions(product)?.join("");			
		const proportionHtml = proportions ? `<div
            class="mb-[5px] text-[10px]/[15px] uppercase text-dusty" style="letter-spacing: .02em; font-weight: 500"
          >
            Available in ${proportions}
          </div>` : '';	

		let discountMsgHtml = '';
		if (discountMsg && discountMsg.length) {
			discountMsgHtml = `<div
								class="mb-[5px] text-[11px]/[16px] font-semibold display_none md:inline-block" style="letter-spacing: .02em;"
							  >`;
			discountMsg.split(',').forEach((discountTag, index) => (
			  discountMsgHtml = `${discountMsgHtml}<p class="mb-0">
			    ${discountTag}
			  </p>`
		    ))
			discountMsgHtml = `${discountMsgHtml}</div>`;
		}		
		
		let priceRangeHtml = '';
		if (priceRange) {
			if (priceRange.type === 'range') {
				priceRangeHtml = `<div class="flex flex-wrap">
                  <div class="w-full flex mb-[6px]">
                    <div class="line-through opacity-[0.4]">
                      $${priceRange.listPrice}
                    </div>

                    <div class="flex text-ruby ml-2">
                      $${priceRange.minSalePrice}&nbsp;
                      &#8211;&nbsp;
                      $${priceRange.maxSalePrice}
                    </div>
                  </div>
				</div>`;
			}
			else if (priceRange.type === 'list-price') {
				priceRangeHtml = `<div class="flex flex-wrap">
					${priceRange.listPrice}
				</div>`;
			}
			else if (priceRange.type === 'no-range') {
				priceRangeHtml = `<div class="flex flex-wrap">
					<div class="w-full flex mb-[6px]">
					  <div class="line-through opacity-[0.4]">
						$${priceRange.listPrice}
					  </div>

					  <div class="flex text-ruby ml-2">
						$${priceRange.salePrice}
					  </div>
					</div>
				</div>`;
			}
			else if (priceRange.type === 'sale-price-range') {
				priceRangeHtml = `<div class="flex">
                    <div class="flex">
                      $${priceRange.minSalePrice}&nbsp;
                      &#8211;&nbsp;
                      $${priceRange.maxSalePrice}
                    </div>
                  </div>`;
			}			
		}
		const placeholderImage =
			'https://cdn.shopify.com/s/files/1/0554/0718/2011/files/NYCO_Placeholder_image.avif?v=1704875304';
			
		const firstImage =
		  product?.v_images && product?.v_images?.length
			? product?.v_images[0]
			: product?.images?.edges?.length > 0
			? product?.images?.edges[0]?.node?.url
			: placeholderImage;

		const videoSources =
		  product?.media?.edges?.length > 1 &&
		  product?.media?.edges[1]?.node?.mediaContentType === 'VIDEO' &&
		  product?.media?.edges[1]?.node?.sources;
		let videoUrl;
		if (videoSources?.length) {
		  const videoUrls = videoSources.filter(
			(videoSrc) => videoSrc?.format !== 'm3u8',
		  );
		  videoUrl = videoUrls?.length ? videoUrls[0].url : videoSources[0].url;
		}
	    const altImage = videoUrl
		  ? videoUrl
		  : product?.v_images && product?.v_images?.length > 1
		  ? product?.v_images[1]
		  : product?.images?.edges?.length > 1
		  ? product?.images?.edges[1]?.node?.url
		  : placeholderImage;
	  
		const quickViewButtonMob = `<div data-quick-view 
			class="absolute z-5 right-[5px] p-[10px] bottom-1 display_block 
			lg:display_none cursor-pointer"
			data-product-title="${product.title}"
			data-product-handle=${product.handle}
			data-discount-tags=${JSON.stringify(discountMsg)}
			data-price="${priceRange?.['priceForGTM']}"
			data-image="${firstImage}"
			>
				<svg width="15" height="19" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M9.08345 6.0835V8.1665H10.3334V6.0835H11.6639L12.2417 14.7503C12.2897 15.4718 11.7175 16.0835 10.9944 16.0835H3.00552C2.28244 16.0835 1.71019 15.4718 1.75829 14.7503L2.33608 6.0835H3.66678V8.1665H4.91678V6.0835H9.08345ZM10.3334 4.8335H12.8333L13.4889 14.6672C13.5851 16.1102 12.4406 17.3335 10.9944 17.3335H3.00552C1.55936 17.3335 0.414858 16.1102 0.511055 14.6672L1.16664 4.8335H3.66678V3.99984C3.66678 2.15889 5.15917 0.666504 7.00012 0.666504C8.84106 0.666504 10.3334 2.15889 10.3334 3.99984V4.8335ZM4.91678 4.8335V3.99984C4.91678 2.84924 5.84952 1.9165 7.00012 1.9165C8.15071 1.9165 9.08345 2.84924 9.08345 3.99984V4.8335H4.91678Z" fill="#171011">
				</path>
				</svg>
			</div>`;	
		const quickViewButton = `<button 
			type="button"
			class="quick-view-btn absolute left-[5px] right-[5px] p-[10px] bg-white/[.9] z-10 transition-bottom ease-in-out
					delay-150 duration-[700ms] bottom-[25px] uppercase display_none lg:display_block"
			data-quick-view
			data-product-title="${product.title}"
			data-product-handle=${product.handle}
			data-discount-tags=${JSON.stringify(discountMsg)}
			data-price="${priceRange?.['priceForGTM']}"
			data-image="${firstImage}"
			>
			Quick View
			</button>`;	
		const mainImageHtml = `<img class="primary-img absolute inset-0 w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-0"
			src="${firstImage}" alt="${product.title}" loading="lazy" sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw">`;
		const hoverImageHtml = videoUrl ?
		`<video class="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100"
           preload="none" autoplay muted loop playsinline>
		  <source src="${videoUrl}" type="video/mp4">
		</video>`
		: `<img class="hover-img absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-300 group-hover:opacity-100" 
			src="${altImage}" alt="${product.title}" loading="lazy" sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw">`;
		<!-- old starts -->
		card.innerHTML = `
		  <div class="card-product group relative w-full aspect-[3/4] overflow-hidden">
		  
			<!-- Media wrapper wrapped with link -->
			<a class="product-link block relative w-full aspect-[3/4] overflow-hidden" href="${productUrl}">
				${mainImageHtml}
				${hoverImageHtml}
				${badgeHtml}	
			</a>
			${quickViewButtonMob}
			${quickViewButton}
		  </div>
          <div class="px-1 sm:px-2 md:px-3 lg:px-4 py-3">
			<div class="swatches flex mb-2"></div>
			${bwlHtml}
			${proportionHtml}
            <a class="product-link block product-title" href="${productUrl}">
			  <h3 class="text-sm font-semibold">${product.title}</h3>
			</a>	
			${discountMsgHtml}
            <div class="text-black-500 text-sm font-medium product-price">${priceRangeHtml}</div>
          </div>`;

		card.querySelectorAll(".product-link").forEach(
			prodLinkEl => prodLinkEl.addEventListener('click', () => {
				pageNoToAppend = card.dataset.pageNo;
				updateURL();
				window.GTMEventBus.publish(eventConstants.SELECT_ITEM, {product});
			})
		)  
		// Swatches
		const swatchesContainer = card.querySelector(".swatches");
		let foundDefaultSwatch = false;
		product.availableColors.forEach((colorInfo, i) => {
			const swatch = document.createElement("button");
			const primaryImage = colorInfo?.["primary_image"];
			const hoverImage = colorInfo?.["hover_image"];
			const isSelected = !foundDefaultSwatch && (firstImage === primaryImage || firstImage === hoverImage);
			if (isSelected) {
				foundDefaultSwatch = true;
			}
			swatch.className = "rounded-full swatch" + (isSelected ? " selected" : "");
			swatch.innerHTML = `<img
				width="18"
				height="18"
				title="${colorInfo.color_name}"
				alt="${colorInfo.color_name}"
				class="rounded-full border border-black"
				src="${colorInfo.color_swatch_image}"
				/>`;
			swatch.addEventListener("click", () => {
				card.querySelectorAll(".swatch").forEach(s => s.classList.remove("selected"));
				swatch.classList.add("selected");
				card.querySelector(".primary-img").src = primaryImage;
				card.querySelector(".hover-img").src = hoverImage;
			});
			swatchesContainer.appendChild(swatch);
	  	});
		if (!foundDefaultSwatch) {
			const firstSwatch = swatchesContainer.querySelector('.swatch');
			if (firstSwatch) {
				firstSwatch.classList.add('selected');
				if (product.availableColors && product.availableColors.length) {
					const firstAvailableColor = product.availableColors[0];
					const primaryImage = firstAvailableColor["primary_image"];
					const hoverImage = firstAvailableColor["hover_image"];
					if (primaryImage) {
						card.querySelector(".primary-img").src = primaryImage;
					}
					if (hoverImage) {	
						card.querySelector(".hover-img").src = hoverImage;
					}
				}
			}
		}
		return card;
	}

    // Render products
    function renderProducts(list, append = true, prepend = false) {
      if (!append && !prepend) grid.innerHTML = "";
	  const fragment = document.createDocumentFragment();
	  const productCards = [];
      list.forEach(product => {
    	const productCard = renderProductCard(product);
		// productCards.push(productCard);
		fragment.appendChild(productCard);
      });

	  /* for (const element of productCards) {
		fragment.appendChild(element);
	  } */

	  styleCountEl.innerHTML = `${productCount} styles`;
	  let prevHeight=0;
	  if (prepend) {
		// const firstChildren = grid.children[0];
		grid.prepend(fragment);
		// const newHeight=productGrid.scrollHeight;
    	// window.scrollTo({top: 235, behavior:'auto'});
	  } else {
		grid.append(fragment);
	  }
    }

    // Build filters dynamically
    function buildFilters(boostResult) {
      filtersPanel.innerHTML = `<button class="filter-close close-btn p-2"></button>
		<div class="border-b -ml-2 mt-[50px] pb-8 text-left text-xs/[12px] uppercase">Filter</div>`;
      
	  const facetResults = [];
	  const textFacets = retrieveFacets(boostResult?.filter?.options);
	  textFacets && textFacets.length && facetResults.push(...textFacets);
	  const rangeFacets = retrieveFacets(boostResult?.facets?.range?.list);
	  rangeFacets && rangeFacets.length && facetResults.push(...rangeFacets);

	  facetResults?.forEach((facet) => {
		const availableFacet = facet?.values?.filter((facetValue) => {
		  return facetValue.doc_count > 0;
		});
		facet.values = availableFacet;
	  });

      facetResults.forEach(facet => {
        const values = facet.values;
		
		const section = document.createElement("div");
	    section.className = "border-b pr-2 cursor-pointer";

	    const header = document.createElement("div");
	    header.className = "flex py-5 justify-between items-center text-xs/[12px] md:text-[13px]/[13px]";
	    header.innerHTML = `<span class="uppercase">${facet.displayName}</span> <span class="toggle-icon collapsed"></span>`;
	    section.appendChild(header);

	    const content = document.createElement("div");
	    content.className = "mb-4 space-y-2 max-h-[200px] overflow-y-auto display_none";
		
		if (facet.displayName.toLowerCase() === "size") {
		  // ✅ Size filter → boxes
		  const wrapper = document.createElement("div");
		  wrapper.className = "flex flex-wrap";
		  values.forEach(v => {
		    const box = document.createElement("span");
		    box.textContent = v.key;
		    box.dataset.value = v.key;
		    box.className = `mb-4 mr-3 p-[2px] flex border border-solid border-black
				cursor-pointer text-[11px] min-w-[56px] min-h-[34px] justify-center items-center`;
			// For size filter box
			box.addEventListener("click", () => {
			  if (!selectedFilters[facet.filterOptionId]) selectedFilters[facet.filterOptionId] = [];
			  if (selectedFilters[facet.filterOptionId].includes(v.key)) {
				selectedFilters[facet.filterOptionId] = selectedFilters[facet.filterOptionId].filter(val => val !== v.key);
				// box.classList.remove("border-300", "border");
				box.classList.add("border-2");
			  } else {
				selectedFilters[facet.filterOptionId].push(v.key);
				box.classList.remove("border-2");
				// box.classList.add("border-300", "border");
			  }
			  box.classList.toggle("border-2");
			  if (!isMobile) {
				page = 1;        // ✅ refresh grid only
				firstPageNumber = 1;
				lastPageNumber = 1;
				lastPage = false;
				// grid.innerHTML = "";
				loadProducts(false, false);
			  }
			});

		    // default border style
			const selectedSizes = selectedFilters[facet.filterOptionId];
			if (selectedSizes?.includes(v.key)) {
				box.classList.add("border-2");
			}
		    wrapper.appendChild(box);
		  });
		  content.appendChild(wrapper);
		} else {
		  // ✅ Other filters → checkboxes
		  values.forEach(v => {
			const selectedSizes = selectedFilters[facet.filterOptionId];
			const isChecked = selectedSizes?.includes(v.key) ? "checked" : "";
		    const swatchColor = swatchColorMap?.[v.key];
			const borderColor = !swatchColor || swatchColor?.toUpperCase() === '#FFF' || swatchColor?.toUpperCase() === '#FFFFFF'
				? 'border border-black' : '';
			let colorFilterSwatch	= '';
			let filterDisplayName = v.key;
			if (facet.displayName?.toLowerCase().includes('color')) {
				colorFilterSwatch = `<span
					class='w-4 h-4 rounded-full inline-block mr-2 ${borderColor}'
					style='background-color: ${swatchColor}'
				></span>`;
			}
			if (facet.displayName?.toLowerCase().includes('price')) {
		    	filterDisplayName = PRICE_RANGE_LABELS[v.key]
        		? PRICE_RANGE_LABELS[v.key] : '$' + v.key.replace('-', ' - $');
			}
		    const lbl = document.createElement("label");
		    lbl.className = "mb-3 mr-3 p-[2px] text-sm flex items-center text-[11px]";
		    lbl.innerHTML = `
				<input type="checkbox" class="w-[18px] h-[18px] mr-[14px]" name="${facet.filterOptionId}" value="${v.key}" ${isChecked}> 
				${colorFilterSwatch}
				${filterDisplayName}`;
			// For checkbox filters
			lbl.querySelector("input").addEventListener("change", e => {
			  if (!selectedFilters[facet.filterOptionId]) selectedFilters[facet.filterOptionId] = [];
			  if (e.target.checked) {
				selectedFilters[facet.filterOptionId].push(v.key);
			  } else {
				selectedFilters[facet.filterOptionId] = selectedFilters[facet.filterOptionId].filter(val => val !== v.key);
			  }
			  if (!isMobile) {
				page = 1;        // ✅ refresh grid only
				firstPageNumber = 1;
				lastPageNumber = 1;
				lastPage = false;
				// grid.innerHTML = "";
				loadProducts(false, false);
			  }
			});
		    content.appendChild(lbl);
		  });
		}
		
        section.appendChild(content);

        // Accordion toggle
        header.addEventListener("click", () => {
          content.classList.toggle("display_none");
          const icon = header.querySelector(".toggle-icon");
          // icon.textContent = content.classList.contains("display_none") ? "+" : "−";
		  if (content.classList.contains("display_none")) {
			icon.classList.add('collapsed');
			icon.classList.remove('expanded');
		  } else {
			icon.classList.add('expanded');
			icon.classList.remove('collapsed');
		  }
        });

        filtersPanel.appendChild(section);
      });
      // add this to align apply button at bottom bottom-[30px]
	  filtersPanel.insertAdjacentHTML('beforeend', `<div class="panel-footer absolute left-0 right-0">
			<button class="inline-block my-8 mx-auto py-[14px] px-[22px] uppercase bg-black text-xs/[12px] text-white cursor-pointer 
			min-w-[80%] display_block lg:display_none"
			id="apply-filters">VIEW ITEMS</button>
		</div>`);
	  filtersPanel.querySelector('.filter-close').addEventListener("click", () => {
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
      });
	  overlayEl.addEventListener("click", () => {
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
      });
	  filtersPanel.querySelector('#apply-filters').addEventListener("click", () => {
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
		page = 1;        // ✅ refresh grid only
		firstPageNumber = 1;
		lastPageNumber = 1;
		lastPage = false;
		loadProducts(false, false);
      });
    }

	let filtersBuilt = false; // track if filters are already built

	async function initialProductsLoad() {
		await loadProducts(false, false);
		initialLoad = false;
	} 

    // Load products from API
    async function loadProducts(append = true, prepend = false) {
      if (loading || (totalPages !== 0 && page > totalPages)) return;
      loading = true;
      /* if (!prepend) {
		loader.classList.remove("display_none");
	  } else {
		topLoader.classList.remove("display_none");
	  }	*/

      const data = await fetchProducts({ page, filters: selectedFilters, sort: selectedSort });
	  
	  // const productCount = data?.response?.numberOfProducts;
	  searchMessage.innerHTML = `Viewing ${productCount} results for '${searchQuery}'`;
	  searchMessageWrapper.classList.remove("display_none");
	  if (productCount === 0) {
		loading = false;
		topLoader.classList.add("display_none");
		loader.classList.add("display_none");
		if (!append && !prepend) grid.innerHTML = "";
		styleCountEl.classList.add("display_none");
		noResultFound.classList.remove("display_none");
		return;
	  }
	  if (firstPageNumber === 1) {
		topLoader.classList.add("display_none");
	  }
	  if (lastPage) {
		loader.classList.add("display_none");
	  }
	  
	  filterSortWrapper.classList.remove("display_none");
	  noResultFound.classList.add("display_none");
      if (!filtersBuilt) {
        buildFilters(data);
		filtersBuilt = true;
      }
	  const products = data?.products;	
	  const productIds = products?.map((prod) => `gid://shopify/Product/${prod.id}`);
	  const shopifyProducts = await shopifyGraphQL(query, { ids: productIds });
	  const mergedProducts = mergeProductProperties(products, shopifyProducts);	
	  updateURL(); 
	  window.GTMEventBus.publish(eventConstants.VIEW_COLLECTION, {products: mergedProducts, handle: '', query: searchQuery});	
	  const prevScroll = window.scrollY;
  	  const prevHeight = document.body.scrollHeight;

      renderProducts(mergedProducts, append, prepend);
	  styleCountEl.classList.remove("display_none");

	  const newHeight = document.body.scrollHeight;
	  const heightDiff = newHeight - prevHeight;	  
	  if (!prepend) {
	  	const loaderHeight = topLoader.offsetHeight - 10;
		// loader.classList.add("display_none");
		if (!append && page > 1 && initialLoad) {
			// Preserve scroll position after prepending
			// window.scrollTo(0, prevScroll + heightDiff);
			window.scrollTo({
				top: prevScroll + heightDiff,
				behavior: 'smooth'
			});
		}		
	  } else if (prepend) {
		  const loaderHeight = topLoader.offsetHeight - 10;
		  // topLoader.classList.add("display_none");
		  // window.scrollTo(0, prevScroll + heightDiff);		  
			window.scrollTo({
				top: prevScroll + heightDiff,
				behavior: 'smooth'
			});		  
	  }
	  if (!observingTopSentinel && !initialLoad) {
		setTimeout(() => {
			observingTopSentinel = true;
			topObserver.observe(topObserverEl);
		}, 500);
	  }
	  if (!observingBottomSentinel) {
		observingBottomSentinel = true;
		bottomObserver.observe(bottomObserverEl);
	  }
	  loading = false;
	  if (firstPageNumber > 1) {
		topLoader.classList.remove("display_none");
	  }
	  initializeQuickView();
    }

    // Reset and reload products
    function resetAndLoad() {
      page = 1;
	  firstPageNumber = 1;
	  lastPageNumber = 1;
      lastPage = false;
      // grid.innerHTML = "";
      loadProducts(false, false);
    }

	function updateURL() {
		const params = new URLSearchParams();
    	params.set("q", searchQuery);
		if (Object.keys(selectedFilters).length) {
		  for (const [key, values] of Object.entries(selectedFilters)) {
			  values.forEach(v => params.append(key, v));
		  }
		}
		if (selectedSort) params.set("sort", selectedSort);
		if (pageNoToAppend && pageNoToAppend > 1) params.set("page", pageNoToAppend);
		const query = params.toString();
		const newUrl = query ? "?" + query : location.pathname;
		history.replaceState(null, "", newUrl);
	}
	
  	function restoreFromURL() {
		const params = new URLSearchParams(window.location.search);

		selectedFilters = {};
		params.forEach((value, key) => {
			if (key === "sort") {
				selectedSort = value;
				console.log('selectedSort', selectedSort);				
			} else if (key === "page") {
				page = parseInt(value) || 1;
				pageNoToAppend = page;				
				firstPageNumber = page;
				lastPageNumber = page;
			} else if (isValidFacet(key)) {
				if (!selectedFilters[key]) selectedFilters[key] = [];
				selectedFilters[key].push(value);
			}
		});
		const sortOptions = document.querySelectorAll("#sortPanel button");
		const matchingSortOption = Array.from(sortOptions).filter(srt => srt.dataset.sort === selectedSort);
		const selectedSortOption = matchingSortOption?.[0];
		sortValue.innerHTML = selectedSortOption.innerHTML;
		selectedSortOption.classList.add('selected');
	}
    
	let lastY = window.scrollY;
	let userHasScrolled = false;
	window.addEventListener('scroll', () => {
		const y = window.scrollY;
		
		const isScrollUp = y < lastY;
		lastY = y;

		// if user scrolled up manually and they had scrolled down before, enable the top observer
		if (!userHasScrolled && !loading && isScrollUp) {
			userHasScrolled = true;
			observingTopSentinel = true;
			topObserver.observe(topObserverEl);
		}
	});

	// Infinite scroll
	/* let lastScrollTop = 0;
	window.addEventListener("scroll", () => {
	  const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
	  if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 200 && !loading && lastPageNumber < totalPages) {
		lastPageNumber++;
		page = lastPageNumber;            // ✅ increment once
		console.log('loading page ::', page);
		loadProducts(true, false);
	  }

	  // load previous page
	  let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
	  if (currentScrollTop < lastScrollTop && window.scrollY < 235 && !loading && firstPageNumber > 1) {
		firstPageNumber--;
		page = firstPageNumber;         // ✅ increment once
		console.log('loading page ::', page);
		loadProducts(false, true);
	  }
	  lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
	}); */

	window.addEventListener('resize', () => {
	  isMobile = window.innerWidth <= 1024;
	});

	const bottomObserver = new IntersectionObserver(entries => {
		for (let entry of entries) {
			const lastCard = entry;
			if (lastCard.isIntersecting && !loading && !initialLoad) {
				if (lastPageNumber < totalPages) {
					lastPageNumber++;
					page = lastPageNumber;
					// loader.classList.remove('hidden');			
					bottomObserver.unobserve(bottomObserverEl);	
					observingBottomSentinel = false;
					loadProducts(true, false);
				}
				// lastCardObserver.unobserve(lastCard.target);
			}
		}
	},
	{
		rootMargin: '100%'
	});

	const topObserver = new IntersectionObserver(entries => {
		for (let entry of entries) {
			const firstCard = entry;
			if (firstCard.isIntersecting && !loading && !initialLoad) { 
				if (firstPageNumber > 1) {
					firstPageNumber--;
					page = firstPageNumber;
					// topLoader.classList.remove('hidden');
					topObserver.unobserve(topObserverEl);
					observingTopSentinel = false;
					loadProducts(false, true);
				}
				// firstCardObserver.unobserve(firstCard.target);
			}
		}
	},
	{
		rootMargin: '100%'
	});		

    // Toggle panels
    filterToggle.addEventListener("click", () => {
      // filtersPanel.classList.toggle("display_none");
	  filtersPanel.classList.remove("translate-x-full", "md:-translate-x-full");
	  overlayEl.classList.add('active');
	  document.body.style.overflow = 'hidden';
      // sortPanel.classList.add("display_none");
	  // sortPanel.classList.add("translate-x-full", "md:-translate-x-full");
	});
    sortToggle.addEventListener("click", () => {
      //sortPanel.classList.toggle("display_none");
	  sortPanel.classList.remove("-translate-x-full", "md:translate-x-full");
      // filtersPanel.classList.add("display_none");
      // filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
	  overlayEl.classList.add('active');
	  document.body.style.overflow = 'hidden';
    });

	sortCloseBtn.addEventListener("click", () => {
      //sortPanel.classList.toggle("display_none");
	  sortPanel.classList.add("-translate-x-full", "md:translate-x-full");
      // filtersPanel.classList.add("display_none");
      // filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
	  overlayEl.classList.remove('active');
	  document.body.style.overflow = '';
    });
    // Close panels on outside click
    document.addEventListener("click", e => {
      if (!filtersPanel.contains(e.target) && !filterToggle.contains(e.target)) {
        // filtersPanel.classList.add("display_none");
		filtersPanel.classList.add("translate-x-full", "md:-translate-x-full");
		if (!sortPanel.contains(e.target) && !sortToggle.contains(e.target)) {
			overlayEl.classList.remove('active');
			document.body.style.overflow = '';
		}
      }
      if (!sortPanel.contains(e.target) && !sortToggle.contains(e.target)) {
        // sortPanel.classList.add("display_none");
		sortPanel.classList.add("-translate-x-full", "md:translate-x-full");
		if (!filtersPanel.contains(e.target) && !filterToggle.contains(e.target)) {
			overlayEl.classList.remove('active');
			document.body.style.overflow = '';
		}
      }
    });

    // Handle sort buttons
    sortPanel.querySelectorAll("button.sort-btn").forEach(btn => {
      btn.addEventListener("click", () => {
		sortPanel.querySelectorAll("button.sort-btn").forEach(sortbtn => sortbtn.classList.remove('selected'));
		btn.classList.add('selected')
        selectedSort = btn.dataset.sort;
		sortValue.innerHTML = btn.innerHTML;
        resetAndLoad();
        // sortPanel.classList.add("display_none");
		sortPanel.classList.add("-translate-x-full", "md:translate-x-full");
		overlayEl.classList.remove('active');
		document.body.style.overflow = '';
      });
    });

    // Initial load
	restoreFromURL();
    initialProductsLoad();
	// loadProducts(false, false);
    // topObserver.observe(topObserverEl);
	// bottomObserver.observe(bottomObserverEl);	
	// initialLoad = false;

  } catch(e) { console.error(e); }
})();
})();
